/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";

import { header } from "../../../../../components/api/Header";
import { getEnv } from "../../../../../lib/env";

function Page2({ date }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/sirdaryo/linemap?date=" +
            date,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
        });
      if (res) {
        setData(res.data);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='card statistic-card w-100'>
      <div className='container-fluid sir-sxema'>
        <div className='sir-svg'>
          <svg
            width='100%'
            height='652'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'>
            <defs>
              <symbol
                enableBackground='new 0 0 1920 1080'
                id='svg_354'
                viewBox='0 0 1920 1080'
                xmlSpace='preserve'
                xmlns='http://www.w3.org/2000/svg'
                xmlnsXlink='http://www.w3.org/1999/xlink'>
                <style>
                  {
                    ".st0{fill:none;stroke:#7ea541;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:12}.st4{fill:#4457a6}.st5{fill:none;stroke:#000;stroke-miterlimit:10}.st6{fill:#fff}.st7{font-family:'Poppins-SemiBold'}.st8{font-size:13.9379px}.st9{fill:#2e3192}.st10{font-family:'Poppins-Regular'}.st11{font-size:20.8404px}.st12{font-size:8.6519px}.st13{fill:none;stroke:#000;stroke-width:.25;stroke-miterlimit:10}.st14,.st15{fill:#ef4136}.st15{opacity:.39;enable-background:new}.st16{fill:#fff;stroke:#000;stroke-miterlimit:10}.st23{font-size:20px}.st24{font-size:6.5196px}.st27{enable-background:new}.st37{font-size:12.1365px}.st50{font-family:'Poppins-SemiBoldItalic'}.st62{font-family:'Poppins-Medium'}.st66{opacity:.29;fill:#fff200;stroke:#000;stroke-miterlimit:10;enable-background:new}.st67{fill:#262262}.st69{font-size:25.7696px}.st72{font-size:15px}.st78{opacity:.4;fill:#537898;enable-background:new}.st80{fill:#40536c}.st81{fill:#475d76}.st84{opacity:.5}.st85{fill:#eaf4fc}.st87{fill:#cbe5f7}.st95{opacity:.25}.st102{fill:#f2f7f7}.st131{opacity:.25;fill:#a7c1d5;enable-background:new}.st184{fill:#708eb1}.st202{opacity:.4;fill:#c1dadd;enable-background:new}.st203{fill:#e4eaea}.st204{fill:#c1dadd}.st526{font-size:14.4657px}.st527{font-size:16.1682px}.st532,.st533{fill:none;stroke:#4457a6;stroke-width:11;stroke-miterlimit:10}.st533{fill:#4457a6;stroke-width:9}"
                  }
                </style>
                <path
                  className='st0'
                  d='m1410.8 0 17.5 35.2 18.6 33.5 2.4 27.4-12.8 18.1-35.7 26.9-49.2 32.6 55.3 51.2 33.8 9s16.7 19 16.6 22.8c0 3.8-31.4 48.9-31.4 48.9l-53.3 17.4-21.1 30.5 184.3 34.3s15.9 14.7 16.2 22c.2 7.3 0 29.6 0 29.6l26.7 61.5s24.6 34.5 24.6 39 45.6 77.5 45.6 77.5L1669 768l-4 71.7-66.8 36.7-174.3-9.2-55.9-37.9-18.5-21.8-21.3-9.4-13.7-.3-152.5 12.1s-26.4 14.3-30.6 15.7c-4.2 1.4-35.2 11.1-35.2 11.1l-31.3 87.1-48 90.4 7.2 65.8M265 0l30.1 14.4 10.2 42.4 26.8 30.6 27.5 59.2V269.9l-3.1 14.9-17.8 37.8-19.3 14.4-24.3 15.5h-58.8l-29 2.5-34.5 28-5.2 83.4L152 500l-5.2 66.4v22s-10.8 43.9-10.1 46.9c.7 3.1 13.2 54 13.2 54l11.9 34.6-25.1 148.2'
                />
                <path
                  style={{
                    fill: "#4457a6",
                    stroke: "#4457a6",
                    strokeMiterlimit: 10,
                  }}
                  d='M162 354.9h1126.4v21H162z'
                />
                <path className='st4' d='M1214.3 612.4h338.1v21h-338.1z' />
                <path
                  className='st4'
                  transform='rotate(-60.284 1565.112 745.844)'
                  d='M1513.5 736.3H1617v19.1h-103.5z'
                />
                <path
                  className='st4'
                  d='M1056.8 498.1V374h21v134c-11.6 0-21-4.4-21-9.9zM368.7 786.2v9.9h1179.1c-7-1.5-11.7-4-11.7-6.9 0-1.1.6-2.1 1.8-3H368.7zM162 709h1008.6v9.9H162zM161.7 146.6h1075.1v9.9H161.7z'
                />
                <path
                  className='st4'
                  d='M1076.7 469h261v9.9h-261zM1299 839.6h240.4v9.9H1299zM843 426l3.6 8-337.1 1.9V426zM912.4 576.9l3.9 7.9-577.6 2v-9.9zM1284.3 375.9h9.9V469h-9.9zM1713.5 260h-119.9c-24.8 0-45-20.1-45-45v-51.7c0-24.8 20.1-45 45-45h119.8c24.8 0 45 20.1 45 45V215c0 24.8-20.1 45-44.9 45z'
                />
                <text
                  className='st6 st7 st8'
                  transform='translate(1578.817 229.843)'>
                  {"To\u2019xtagul Suv Ombori"}
                </text>
                <text
                  style={{
                    fontSize: "20px",
                  }}
                  className='st9 st10 st11'
                  transform='rotate(-31.018 1099.032 -2547.258)'>
                  {`${data[520] ? data[520]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path
                  transform='rotate(-31.218 1498.238 196.833)'
                  d='M1466 195.9h64.2v2H1466z'
                />
                <path d='m1465.7 216.5 7.4-.2-3.8-6.3z' />
                <text
                  className='st9 st10 st11'
                  transform='translate(1474.453 597.161)'>
                  {`${data[292] ? data[292]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1483.6 603.9h64.2v2h-64.2z' />
                <path d='m1477.8 604.9 6.5 3.7v-7.5zM930.4 409.9c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={922.6} cy={409.9} r={7.9} />
                <path d='M921.5 384.8h2.1v17.1h-2.1z' />
                <ellipse cx={922.5} cy={382} rx={18.5} ry={3.1} />
                <path d='M622.8 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={614.9} cy={415.8} r={7.9} />
                <path d='M613.9 390.7h2.1v17.1h-2.1z' />
                <ellipse cx={614.9} cy={387.9} rx={18.5} ry={3.1} />
                <path d='M406.2 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={398.3} cy={415.8} r={7.9} />
                <path d='M397.2 390.7h2.1v17.1h-2.1z' />
                <ellipse cx={398.3} cy={387.9} rx={18.5} ry={3.1} />
                <path d='M1221.9 108.9c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9h15.8z' />
                <circle className='st13' cx={1214} cy={108.9} r={7.9} />
                <path d='M1212.9 116.8h2.1v17.1h-2.1z' />
                <ellipse cx={1214} cy={136.8} rx={18.5} ry={3.1} />
                <path d='M982.7 315.1c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9h15.8z' />
                <circle className='st13' cx={974.8} cy={315.1} r={7.9} />
                <path d='M973.8 323.1h2.1v17.1h-2.1zM964.5 315.1c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9h15.8z' />
                <circle className='st13' cx={956.5} cy={315.1} r={7.9} />
                <path d='M955.5 323.1h2.1v17.1h-2.1z' />
                <ellipse cx={965.7} cy={342.8} rx={20.4} ry={5.1} />
                <path d='M280.7 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={272.8} cy={415.8} r={7.9} />
                <path d='M271.7 390.7h2.1v17.1h-2.1zM262.5 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={254.5} cy={415.8} r={7.9} />
                <path d='M253.5 390.7h2.1v17.1h-2.1z' />
                <ellipse cx={263.7} cy={388} rx={20.4} ry={5.1} />
                <path
                  className='st16'
                  d='M1451.4 144.9h-119.7c-2.4 0-4.5-2-4.5-4.5V93.3c0-2.4 2-4.5 4.5-4.5h119.7c2.4 0 4.5 2 4.5 4.5v47c0 2.6-1.9 4.6-4.5 4.6z'
                />
                <text
                  className='st9 st10'
                  transform='translate(1360.958 137.296)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[308] ? data[308]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1419.2 144.9h2.7v119h-2.7z' />
                <text
                  className='st7'
                  transform='translate(1454.317 315.719)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"CHNK"}
                </text>
                <path
                  className='st5'
                  d='M1572.4 349.7h-123.9c-2.5 0-4.6-2.1-4.6-4.6v-48.8c0-2.5 2.1-4.6 4.6-4.6h123.9c2.5 0 4.6 2.1 4.6 4.6v48.6c0 2.7-1.9 4.8-4.6 4.8z'
                />
                <text
                  className='st9 st10'
                  transform='translate(1490.356 340.667)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[523] ? data[523]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1500.3 216.1h2.7v75.5h-2.7zM1181.3 478.9h2.7v27.5h-2.7z' />
                <text
                  className='st7'
                  transform='translate(1429.921 409.833)'
                  style={{
                    fontSize: 23,
                  }}>
                  {"KFMK"}
                </text>
                <path
                  className='st5'
                  d='M1536.6 439.8h-111.9c-2.3 0-4.2-1.9-4.2-4.2v-44.1c0-2.3 1.9-4.2 4.2-4.2h111.9c2.3 0 4.2 1.9 4.2 4.2v44c0 2.4-1.8 4.3-4.2 4.3z'
                />
                <text
                  className='st9 st10 st23'
                  transform='translate(1445.535 432.35)'>
                  {`${data[463] ? data[463]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <text
                  className='st7'
                  transform='translate(1143.518 525.354)'
                  style={{
                    fontSize: 23,
                  }}>
                  {"KAK"}
                </text>
                <path
                  className='st5'
                  d='M1245.7 555.9h-102.1c-2 0-3.6-1.6-3.6-3.6v-42.9c0-2 1.6-3.6 3.6-3.6h102.1c2 0 3.6 1.6 3.6 3.6v42.8c0 2.1-1.5 3.7-3.6 3.7z'
                />
                <text
                  className='st9 st10 st23'
                  transform='translate(1145.46 550.77)'>
                  {`${data[465] ? data[465]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1194 375.9h2.7v29.7h-2.7zM1216.8 308.2h2.7v33.1h-2.7z' />
                <path d='M1219.4 338.7h45.4v2.7h-45.4z' />
                <text
                  className='st7'
                  transform='translate(1162.173 428.176)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"KDP"}
                </text>
                <path
                  className='st5'
                  d='M1243.4 456.1h-105.1c-2 0-3.6-1.6-3.6-3.6v-42.9c0-2 1.6-3.6 3.6-3.6h105.1c2 0 3.6 1.6 3.6 3.6v42.8c0 2.1-1.5 3.7-3.6 3.7z'
                />
                <text
                  className='st9 st10 st23'
                  transform='translate(1158.115 450.016)'>
                  {`${data[464] ? data[464]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M813.8 434.2h2.7v28.9h-2.7z' />
                <text
                  style={{
                    fontSize: "23px",
                  }}
                  className='st27'
                  transform='translate(685.956 485.025)'>
                  {"Zardaryo kanali"}
                </text>
                <path
                  className='st5'
                  d='M877.6 522.1h-190c-2.6 0-4.7-2.1-4.7-4.7v-49.2c0-2.6 2.1-4.7 4.7-4.7h190c2.6 0 4.7 2.1 4.7 4.7v49.1c0 2.7-2 4.8-4.7 4.8z'
                />
                <text
                  className='st9 st10'
                  transform='translate(685.956 512.752)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[324] ? data[324]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1386.5 725.5h5.8v41.7h-5.8z' />
                <text
                  style={{
                    fontSize: "23px",
                  }}
                  className='st27'
                  transform='translate(1310.93 689.08)'>
                  {"Andijonsoy"}
                </text>
                <path
                  className='st5'
                  d='M1449.5 725h-140.7c-2.5 0-4.5-2.1-4.5-4.5V673c0-2.5 2.1-4.5 4.5-4.5h140.7c2.5 0 4.5 2.1 4.5 4.5v47.4c0 2.6-1.9 4.6-4.5 4.6z'
                />
                <text
                  className='st9 st10'
                  transform='translate(1360.545 716.093)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[299] ? data[299]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1427 553.3h5.8V595h-5.8z' />
                <path
                  className='st5'
                  d='M1460 552.9h-120.7c-2.5 0-4.5-2.1-4.5-4.5v-47.5c0-2.5 2.1-4.5 4.5-4.5H1550c2.5 0 4.5 2.1 4.5 4.5v47.4c0 2.6-1.9 4.6-4.5 4.6z'
                />
                <path
                  className='st16'
                  d='M1100.3 308.6H1047c-2.1 0-3.9-1.8-3.9-3.9V258c0-2.1 1.8-3.9 3.9-3.9h203.3c2.1 0 3.9 1.8 3.9 3.9v48.6c0 2.2-1.7 4-3.9 4z'
                />
                <path d='M1268.2 843.2h30.9v2.7h-30.9zM1088.8 751.2h15v2.7h-15zM1103.8 751.2h2.7v35h-2.7z' />
                <text
                  style={{
                    fontSize: "24px",
                  }}
                  className='st27'
                  transform='translate(1133.82 845.476)'>
                  {"Savay k-li"}
                </text>
                <path
                  className='st5'
                  d='M1264.3 877.1h-130.1c-2 0-3.6-1.6-3.6-3.6v-42.9c0-2 1.6-3.6 3.6-3.6h130.1c2 0 3.6 1.6 3.6 3.6v42.8c0 2.1-1.6 3.7-3.6 3.7z'
                />
                <text
                  className='st9 st10 st23'
                  transform='translate(1170.109 870.997)'>
                  {`${data[298] ? data[298]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <text
                  style={{
                    fontSize: "23px",
                  }}
                  className='st27'
                  transform='translate(923.558 743.441)'>
                  {"Shaxrixonsoy"}
                </text>
                <path
                  className='st5'
                  d='M1084.9 775.1h-160.1c-2 0-3.6-1.6-3.6-3.6v-42.9c0-2 1.6-3.6 3.6-3.6h160.1c2 0 3.6 1.6 3.6 3.6v42.8c0 2-1.6 3.7-3.6 3.7z'
                />
                <text
                  className='st9 st10 st23'
                  transform='translate(1000.582 767.963)'>
                  {`${data[300] ? data[300]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M613.1 750.5h15v2.7h-15zM628.1 750.5h2.7v35.7h-2.7z' />
                <text
                  style={{
                    fontSize: "23px",
                  }}
                  className='st27'
                  transform='translate(405.793 748.713)'>
                  {"Polvontosh G/P"}
                </text>
                <path
                  className='st5'
                  d='M508.6 778.3H396c-2.3 0-4.2-1.9-4.2-4.2v-44.3c0-2.3 1.9-4.2 4.2-4.2h212.6c2.3 0 4.2 1.9 4.2 4.2V774c0 2.3-1.8 4.3-4.2 4.3z'
                />
                <text
                  className='st9 st10'
                  transform='translate(500.157 769.916)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[493] ? data[493]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M729 843.3h15v2.7h-15zM744 796.1h2.7v49.8H744z' />
                <text
                  className='st7'
                  transform='translate(610.396 839.972)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"JFK"}
                </text>
                <path
                  className='st5'
                  d='M724.1 873.3H601.7c-2.5 0-4.6-2.1-4.6-4.6v-48.2c0-2.5 2.1-4.6 4.6-4.6h122.4c2.5 0 4.6 2.1 4.6 4.6v48.1c0 2.6-2 4.7-4.6 4.7z'
                />
                <text
                  className='st9 st10'
                  transform='translate(620.396 864.258)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[301] ? data[301]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1384.8 413.3h35.3v2.7h-35.3z' />
                <text
                  className='st7'
                  transform='translate(183.805 634.35)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"KFMK"}
                </text>
                <path
                  className='st5'
                  d='M300 669.8H178.1c-2.5 0-4.6-2.1-4.6-4.6v-48c0-2.5 2.1-4.6 4.6-4.6H300c2.5 0 4.6 2.1 4.6 4.6v47.9c0 2.6-1.9 4.7-4.6 4.7z'
                />
                <text
                  className='st9 st10'
                  transform='translate(183.075 662.516)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[478] ? data[478]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M237.7 669.8h2.7v39.1h-2.7z' />
                <text
                  className='st7'
                  transform='translate(1044.557 204.368)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"SHFMK"}
                </text>
                <text
                  className='st50'
                  transform='rotate(-31.218 1173.125 -2305)'
                  style={{
                    fontSize: "16.8044px",
                  }}>
                  {"Norin"}
                </text>
                <path
                  className='st5'
                  d='M1165.5 240.3H1042c-2.5 0-4.6-2.1-4.6-4.6V187c0-2.5 2.1-4.6 4.6-4.6h123.5c2.5 0 4.6 2.1 4.6 4.6v48.5c0 2.7-1.9 4.8-4.6 4.8z'
                />
                <text
                  className='st9 st10'
                  transform='translate(1088.752 233.909)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[312] ? data[312]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M1102.4 156.6h2.7v25.5h-2.7z' />
                <text
                  className='st7'
                  transform='translate(234.83 232.165)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"SHFMK"}
                </text>
                <path
                  className='st5'
                  d='M348.5 265.9H232.4c-2.4 0-4.3-2-4.3-4.3v-45.7c0-2.4 2-4.3 4.3-4.3h116.1c2.4 0 4.3 2 4.3 4.3v45.6c.1 2.4-1.8 4.4-4.3 4.4z'
                />
                <text
                  className='st9 st10'
                  transform='translate(238.36 257.111)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[493] ? data[493]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path d='M288.1 156.6h3.7v54.6h-3.7zM700.3 314.8c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9h15.8z' />
                <circle className='st13' cx={692.4} cy={314.8} r={7.9} />
                <path d='M691.4 322.6h2.1v17.1h-2.1zM682 314.8c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9H682z' />
                <circle className='st13' cx={674.1} cy={314.8} r={7.9} />
                <path d='M673.1 322.6h2.1v17.1h-2.1zM663.7 314.8c0-4.4-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9h15.8z' />
                <circle className='st13' cx={655.8} cy={314.8} r={7.9} />
                <path d='M654.8 322.6h2.1v17.1h-2.1z' />
                <ellipse cx={675} cy={342.4} rx={30.6} ry={5.1} />
                <path d='M499.8 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={491.8} cy={415.8} r={7.9} />
                <path d='M490.8 390.8h2.1v17.1h-2.1zM481.5 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={473.6} cy={415.8} r={7.9} />
                <path d='M472.5 390.8h2.1v17.1h-2.1zM463.1 415.8c0 4.4-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9h15.8z' />
                <circle className='st13' cx={455.3} cy={415.8} r={7.9} />
                <path d='M454.3 390.8h2.1v17.1h-2.1z' />
                <ellipse cx={474.5} cy={388.1} rx={30.6} ry={5.1} />
                <path
                  className='st14'
                  d='M118.1 944.9v11.6h-13.8v12.3H103v-23.9z'
                />
                <ellipse
                  className='st15'
                  cx={103.5}
                  cy={967.3}
                  rx={18.8}
                  ry={3.9}
                />
                <path
                  className='st14'
                  d='M684.5 750.9V766h-17.8v15.9h-1.6v-31z'
                />
                <ellipse
                  className='st15'
                  cx={665.6}
                  cy={780}
                  rx={24.3}
                  ry={5.1}
                />
                <path d='M964.4 640.7h14.9v2.7h-14.9zM979.3 640.7h2.7V709h-2.7z' />
                <text
                  className='st27'
                  style={{
                    fontSize: "23px",
                  }}
                  transform='translate(745.672 633.129)'>
                  {"KFMK I-II chegara"}
                </text>
                <path
                  className='st5'
                  d='M959.4 671.2H734.5c-2.5 0-4.7-2.1-4.7-4.7v-49.2c0-2.5 2.1-4.7 4.7-4.7h224.8c2.5 0 4.7 2.1 4.7 4.7v49c0 2.7-2 4.9-4.6 4.9z'
                />
                <text
                  className='st9 st10'
                  transform='translate(750.936 663.654)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[472] ? data[472]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path
                  className='st14'
                  d='M1044.7 670.7v15h-17.8v16h-1.6v-31z'
                />
                <ellipse
                  className='st15'
                  cx={1025.8}
                  cy={699.7}
                  rx={24.3}
                  ry={5.1}
                />
                <text
                  className='st7'
                  transform='translate(753.895 234.067)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"KAL G/P"}
                </text>
                <path
                  className='st5'
                  d='M878 269.9H752.3c-2.6 0-4.7-2.1-4.7-4.7v-49.4c0-2.6 2.1-4.7 4.7-4.7H878c2.6 0 4.7 2.1 4.7 4.7v49.4c.1 2.7-2 4.7-4.7 4.7z'
                />
                <text
                  className='st9 st10'
                  transform='translate(790.287 263.48)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {`${data[557] ? data[557]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <path
                  className='st14'
                  d='M868.2 313.7v15.1h-17.8v15.9h-1.6v-31z'
                />
                <ellipse
                  className='st15'
                  cx={849.3}
                  cy={342.7}
                  rx={24.3}
                  ry={5.1}
                />
                <path className='st14' d='M807.9 270.7h1.9v72.5h-1.9z' />
                <path
                  className='st15'
                  d='M825.9 342.6v.2c0 .2-.1.3-.3.3h-17v-.9h17c.1.1.3.2.3.4z'
                />
                <path className='st66' d='M865.1 35.3h193.5v40.4H865.1z' />
                <text
                  className='st67 st7'
                  transform='translate(878.249 64.71)'
                  style={{
                    fontSize: "26.0438px",
                  }}>
                  {"O\u2018zbekiston"}
                </text>
                <path className='st66' d='M102.4 35.3h151.9v40H102.4z' />
                <text
                  className='st67 st7 st69'
                  transform='translate(113.855 64.676)'>
                  {"Tojikiston"}
                </text>
                <path className='st66' d='M1641.1 35.3h169.7v40h-169.7z' />
                <text
                  className='st67 st7 st69'
                  transform='translate(1652.568 64.676)'>
                  {"Qirg\u2019iziston"}
                </text>
                <text
                  className='st62'
                  transform='translate(80.558 923.804)'
                  style={{
                    fontSize: "16.9441px",
                    opacity: 0.6,
                    enableBackground: "new",
                  }}>
                  {"Shartli belgilar"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(136.64 964.77)'>
                  {"Suv o\u2019lchash posti"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(136.377 1014.21)'>
                  {"Nasos stansiya"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(342.823 963.953)'>
                  {"Gidrouzel"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(342.823 1010.31)'>
                  {"Daryo"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(517.438 963.77)'>
                  {"Kanal"}
                </text>
                <text
                  className='st10 st72'
                  transform='translate(517.438 1010.31)'>
                  {"Davlat chegarasi"}
                </text>
                <path className='st5' d='M65.1 900.5h586.6v134.3H65.1z' />
                <path d='M110.6 1000.2c0-3.4-2.7-6.1-6.1-6.1-3.4 0-6.1 2.7-6.1 6.1h12.2z' />
                <circle className='st5' cx={104.5} cy={1000.2} r={6.1} />
                <path d='M103.7 1006.3h1.7v13.3h-1.7z' />
                <path
                  className='st4'
                  d='M454.8 956h50.5v8.8h-50.5zM279.2 996.9h50.5v18.3h-50.5z'
                />
                <path
                  d='M505 1008.1h-8v-2h8v2zm-15.8 0h-8.1v-2h8.1v2zm-15.9 0h-8.1v-2h8.1v2zm-15.9 0h-8.1v-2h8.1v2zm-16 0h-8.1v-2h8.1v2z'
                  style={{
                    fill: "#7ea641",
                  }}
                />
                <path
                  style={{
                    fill: "url(#SVGID_1_)",
                  }}
                  d='M1581.3 148h14.2v10.4h-14.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_352'
                  x1={1576.07}
                  x2={1585.67}
                  y1={885.63}
                  y2={913.16}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_352)'
                  d='M1580.6 202.4h-14.2l14.9-44.1h14.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_351'
                  x1={1580.65}
                  x2={1601.6}
                  y1={899.63}
                  y2={899.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_351)'
                  d='M1601.6 158.3v44.1h-21l.9-2.4 14.1-41.7z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_350'
                  x1={1595.57}
                  x2={1601.62}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_350)' d='M1595.6 148h6v10.4h-6z' />
                <path
                  className='st6'
                  d='M1583 174.5c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-.1-4.5-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.4.3-3.8-1.5-3.9zm-5 3.9h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.9.1-3.6 1.5-4.6 3.9zm1 .6h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1-.1-1.5-1-.9-2.6zM1586.6 174.5l-1.4 3.6h1.1l1.4-3.6h-1.1zm-.1-4.5-.4 1h1.9l-1.1 2.9h1.1l1.5-3.9h-3z'
                />
                <path
                  className='st78'
                  d='M1599 180.5c0-.1-.2-.1 0 0 .7-3.2 1.2-5.7 1.6-7.4h.1v.1c-.4 1.6-1.1 4.1-1.7 7.3 0-.1 0 0 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_349'
                  x1={1614.12}
                  x2={1614.12}
                  y1={914.85}
                  y2={921.69}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1626.6 158.3-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_349)'
                />
                <path
                  className='st80'
                  d='m1626.2 159.3-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1625.9 159.3-.1.4-2.4 7h-13.9V162c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1625.7 159.9-2.5 7.5h-10.4v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_348'
                  x1={1606.16}
                  x2={1606.16}
                  y1={877.59}
                  y2={916.81}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1624.8 163.2-11.1 32.5-.9 2.5-.5 1.7-.8 2.4h-24c0-.8 0-1.5.1-2.4.1-.9.2-1.7.3-2.7.4-2.3 1-4.8 1.7-7.2 1.7-6 4.1-12 5.7-16.9 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3h15.9z'
                  fill='url(#svg_348)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_347'
                  x1={1587.31}
                  x2={1624.8}
                  y1={897.18}
                  y2={897.18}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1624.8 163.2-11.1 32.5-.9 2.5-.5 1.7-.8 2.4h-24c0-.8 0-1.5.1-2.4.1-.9.2-1.7.3-2.7.4-2.3 1-4.8 1.7-7.2 1.7-6 4.1-12 5.7-16.9 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3h15.9z'
                  enableBackground='new'
                  fill='url(#svg_347)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1589.5 199.2c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.6 2.7-1.1 5.4-1.5 8.2.1 0 0 0 0 0zM1609.9 199.2c-.1 0-.1 0 0 0 .3-2.8.9-5.6 1.4-8.3h.1v.1c-.7 2.7-1.1 5.4-1.5 8.2zM1592.3 185.5c-.1 0-.1 0 0 0 .7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1.1 3-1.8 5.9-2.6 8.6zM1613 185.5s-.1 0 0 0c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-.9 3-1.8 5.9-2.6 8.6zM1596.2 172.7c0-.1 0-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c.1-.1.1 0 0 0zM1616.4 172.7c-.1-.1-.1-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c0-.1 0 0 0 0zM1599.8 199.2s-.1 0 0 0c0-.1.4-2.5 1.1-5.9h.1v.1c-.6 3.3-1.2 5.7-1.2 5.8zM1602.3 185.9c1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.5 2.5-1.4 6.8-2.6 12.4.1 0 .1 0 0 0zM1608.3 167.4c0-.1 0-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1 .2-2.6.9-4.1 2z'
                  />
                  <path
                    className='st78'
                    d='M1603.9 200.7c-.1 0-.1 0 0 0 .1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.3-2.4 10.3-2.6 11.5zM1608.1 181.7s0-.1 0 0c.3-1.6.7-3.3 1.1-5h.1v.1c-.3 1.6-.7 3.2-1.2 4.9.1 0 0 0 0 0zM1610.4 172c.4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.6.7-3.6 2.5-4.8 5.8.1 0 .1 0 0 0zM1594.8 200.7c0-.7.3-1.9.5-3.5h.1v.1c-.2 1.5-.4 2.7-.6 3.4.1 0 0 0 0 0zM1596.7 191.6c-.1 0-.1 0 0 0 .3-1.7.7-3.4 1-5h.1v.1c-.5 1.5-.8 3.3-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_346'
                  x1={1600.59}
                  x2={1600.59}
                  y1={877.57}
                  y2={886.13}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='M1615.3 202.1v.3h-28.6c-.5-.5-.9-1.3-.9-2.3v-.1c0-1.3.9-2.5 2-2.7h.4c.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5.3-.2.9-.2 1.4-.2 1.1 0 2.1.8 2.4 1.9.4.1.9.2 1.2.4.2-.7 1-1.2 1.7-1.2 1 0 1.9.8 1.9 1.9 0 .2 0 .4-.1.7.3-.1.7-.1 1-.1.5 0 1.1.1 1.5.4h.2c.8.4 1.4 1 1.9 1.7.4.5.7 1.2.7 1.9z'
                  fill='url(#svg_346)'
                />
                <path
                  className='st87'
                  d='M1588.7 202.4h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1 0 .3.1.7.3 1 0 .2 0 .3.1.4zM1605.4 196.3c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.5 0 1 .1 1.3.2zM1608.8 198.7l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.1.3.4.7.6 1zM1607.7 200c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.1c0-.1.1-.1.1-.2.1-.2.2-.4.2-.8 0-.2-.1-.5-.2-.8s-.3-.4-.5-.7c.1 0 .1.1.2.1l.3.3c.3.3.5.8.5 1.2 0 .3.2.5.5.5h4.6v-.3c0-.5.2-1.1.5-1.7 0-.1.1-.2.1-.2 0 .1 0 .2-.1.2zM1599.2 200.7v.2c0 .5-.2 1.1-.4 1.5h-6c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1v.9zM1590.6 198.7c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.5.3 1 1 1 1.5z'
                />
                <defs>
                  <path id='svg_345' d='M615-212.6h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_343' d='M612.8-214.8h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_344'>
                  <use overflow='visible' xlinkHref='#svg_345' />
                </clipPath>
                <clipPath id='svg_334'>
                  <use overflow='visible' xlinkHref='#svg_343' />
                </clipPath>
                <mask
                  height={13.5}
                  id='svg_336'
                  maskUnits='userSpaceOnUse'
                  width={35}
                  x={1583.2}
                  y={188.9}>
                  <g
                    style={{
                      filter: "url(#Adobe_OpacityMaskFilter)",
                    }}>
                    <defs>
                      <path id='svg_341' d='M615-212.6h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_339' d='M612.8-214.8h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_340'>
                      <use overflow='visible' xlinkHref='#svg_341' />
                    </clipPath>
                    <clipPath id='svg_337'>
                      <use overflow='visible' xlinkHref='#svg_339' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_338'
                      x1={1600.76}
                      x2={1600.76}
                      y1={877.57}
                      y2={890.9}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_337)'
                      d='M1618.3 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.6.1 3.2 1.8 3.2 3.7z'
                      fill='url(#svg_338)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_335'
                  x1={1600.76}
                  x2={1600.76}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_334)'
                  d='M1618.3 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.6.1 3.2 1.8 3.2 3.7z'
                  fill='url(#svg_335)'
                  mask='url(#svg_336)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_333'
                  x1={1600.76}
                  x2={1600.76}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1618.3 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.6.1 3.2 1.8 3.2 3.7z'
                  enableBackground='new'
                  fill='url(#svg_333)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1589.6 194.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2zM1586.2 200.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zM1596.7 191.2c0 .1-.1.1-.1.1l-.1-.1c0-.1.1-.1.1-.1l.1.1zM1592.8 191.8c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1603.6 193.6c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0 0 0 0zM1606.5 194.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1601.2 191.8s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0 0-.1 0-.1 0 0zM1594.6 193.2c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1584.1 198.7c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1589.2 192.2s-.1 0 0 0c-.1.1-.1 0-.1 0-.1-.2 0-.2.1 0-.1-.2 0-.2 0 0zM1588.5 196.5c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1607.1 192.9c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1610.2 195s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0zM1611.4 193.6s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0 0-.1 0-.1 0 0zM1611.7 196.4s0 .1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1614.6 196.3s-.1 0 0 0c-.1.1-.1 0-.1 0-.2-.1 0-.1.1 0-.1-.1 0-.1 0 0zM1614.8 199c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1616.6 201c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1616 201.9c0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_332'
                  x1={1633.33}
                  x2={1633.33}
                  y1={921.69}
                  y2={932.02}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_332)' d='M1626.2 148h14.2v10.4h-14.2z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_331'
                  x1={1617.11}
                  x2={1634.69}
                  y1={875.47}
                  y2={923.76}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_331)'
                  d='m1640.4 158.3-14.1 41.7-.7 2.4h-14.3l.8-2.4.6-1.7.9-2.4 9.6-28.6.1-.5 2.4-6.9.2-.6.3-1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_330'
                  x1={1625.54}
                  x2={1646.49}
                  y1={899.63}
                  y2={899.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_330)'
                  d='M1646.5 158.3v44.1h-20.9l.7-2.4 14.1-41.7z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_329'
                  x1={1640.46}
                  x2={1646.51}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_329)' d='M1640.4 148h6v10.4h-6z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_328'
                  x1={1685.08}
                  x2={1691.12}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_328)' d='M1685.1 148h6v10.4h-6z' />
                <path
                  className='st6'
                  d='m1626.7 170-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.4.1-3.8-1.5-3.9zm-5.2 3.9h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.7.1-3.6 1.5-4.6 3.9zm5.3.6c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-4.3 0h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1-.1-1.3-1-.9-2.6zM1633.2 169.9c-1.2 0-2.5.4-3.4 1.2l.5.7c.8-.5 1.5-.9 2.4-.9 1.1 0 1.5.5 1.2 1.3-.2.4-.5 1-1.5 1.6h1.3c.8-.7 1.1-1.2 1.3-1.7.6-1.3 0-2.2-1.8-2.2zm-3.7 7.1 3.4-2.4c.1-.1.2-.1.3-.2h-1.4l-3.9 2.7-.3.8h5.8l.4-1h-4.3v.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_327'
                  x1={1611.61}
                  x2={1611.61}
                  y1={921.69}
                  y2={930.34}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_327)' d='M1597 149.7h29.2v8.6H1597z' />
                <path
                  className='st102'
                  d='M1625.9 156.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c0 .2-.1.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_326'
                  x1={1599.94}
                  x2={1599.94}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1602.2 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_326)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_325'
                  x1={1604.74}
                  x2={1604.74}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1607 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_325)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_324'
                  x1={1609.54}
                  x2={1609.54}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1611.8 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_324)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_323'
                  x1={1614.34}
                  x2={1614.34}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1616.6 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_323)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_322'
                  x1={1619.14}
                  x2={1619.14}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1621.4 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_322)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_321'
                  x1={1623.95}
                  x2={1623.95}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1626.2 150.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_321)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_320'
                  x1={1597.87}
                  x2={1597.87}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1598.1 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_320)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_319'
                  x1={1607.47}
                  x2={1607.47}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1607.7 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_319)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_318'
                  x1={1611.94}
                  x2={1611.94}
                  y1={923.8}
                  y2={926.39}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1597.6 153.6 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.7v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.8s0 .2 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.9 0s0 .2 0 0l4.5.1c.1 0 .1 0 .1-.1V154l-4.6.2v1.9zm4.8-2v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_318)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1606.7 150.4-2.7 5.9h-1.3l2.8-5.9zM1611 156.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1616.6 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c-.1-.1 0-.1 0 0zM1621.4 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0zM1624.6 150.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_317'
                  x1={1617.07}
                  x2={1617.07}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1617.3 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_317)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_316'
                  x1={1621.87}
                  x2={1621.87}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1622.1 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_316)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_315'
                  x1={1602.72}
                  x2={1602.72}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1603 156.3h-.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.2 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_315)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_314'
                  x1={1612.27}
                  x2={1612.27}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1612.5 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_314)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_313'
                  x1={1656.46}
                  x2={1656.46}
                  y1={921.69}
                  y2={930.34}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_313)' d='M1641.8 149.7h29.2v8.6h-29.2z' />
                <path
                  className='st102'
                  d='M1670.9 156.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c-.1.2-.2.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_312'
                  x1={1644.79}
                  x2={1644.79}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1647.1 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_312)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_311'
                  x1={1649.59}
                  x2={1649.59}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1651.9 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_311)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_310'
                  x1={1654.39}
                  x2={1654.39}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1656.7 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_310)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_309'
                  x1={1659.19}
                  x2={1659.19}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1661.5 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_309)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_308'
                  x1={1663.99}
                  x2={1663.99}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1666.3 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_308)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_307'
                  x1={1668.8}
                  x2={1668.8}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1671.1 150.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_307)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_306'
                  x1={1642.82}
                  x2={1642.82}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1643 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_306)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_305'
                  x1={1652.43}
                  x2={1652.43}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1652.6 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_305)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_304'
                  x1={1656.79}
                  x2={1656.79}
                  y1={923.8}
                  y2={926.39}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1642.5 153.6 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.7v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.8s.1.2 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.8 0s.1.2 0 0l4.5.1c.1 0 .1 0 .1-.1V154l-4.6.2v1.9zm4.8-2v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_304)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1651.7 150.4-2.8 5.9h-1.3l2.8-5.9zM1655.8 156.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1661.5 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c0-.1 0-.1 0 0zM1666.3 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0zM1669.4 150.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_303'
                  x1={1662.03}
                  x2={1662.03}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1662.2 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_303)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_302'
                  x1={1666.83}
                  x2={1666.83}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1667 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_302)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_301'
                  x1={1647.63}
                  x2={1647.63}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1647.8 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_301)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_300'
                  x1={1657.23}
                  x2={1657.23}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1657.4 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2-.1 0 0 0z'
                  fill='url(#svg_300)'
                />
                <path
                  className='st102'
                  d='M1594.2 155.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_299'
                  x1={1582.38}
                  x2={1594.53}
                  y1={927.02}
                  y2={927.02}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1594.5 150.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_299)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1586.3 150.6-1.5 4.7h-1.3l1.5-4.7zM1593.7 150.6l-1.5 4.7h-3.3l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1594.5 152.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_298'
                  x1={1582.59}
                  x2={1582.59}
                  y1={924.69}
                  y2={929.43}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1582.8 155.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7z'
                  fill='url(#svg_298)'
                />
                <path
                  className='st102'
                  d='M1639.1 155.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.1.3-.3.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_297'
                  x1={1627.27}
                  x2={1639.42}
                  y1={927.02}
                  y2={927.02}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1639.4 150.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_297)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1631.1 150.6-1.5 4.7h-1.2l1.5-4.7zM1638.6 150.6l-1.6 4.7h-3.1l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1639.4 152.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_296'
                  x1={1627.55}
                  x2={1627.55}
                  y1={924.69}
                  y2={929.43}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1627.8 155.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7c-.1 0-.1 0 0 0z'
                  fill='url(#svg_296)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_295'
                  x1={1658.97}
                  x2={1658.97}
                  y1={914.85}
                  y2={921.69}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1671.4 158.3-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_295)'
                />
                <path
                  className='st80'
                  d='m1671.1 159.3-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1670.8 159.3-.1.4-2.4 7h-13.9V162c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1670.7 159.9-2.5 7.5h-10.4v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_294'
                  x1={1650.95}
                  x2={1650.95}
                  y1={877.59}
                  y2={916.81}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1669.7 163.2-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  fill='url(#svg_294)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_293'
                  x1={1632.24}
                  x2={1669.72}
                  y1={897.18}
                  y2={897.18}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1669.7 163.2-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  enableBackground='new'
                  fill='url(#svg_293)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1634.3 199.2c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.7-.9 5.4-1.5 8.2.1 0 .1 0 0 0zM1654.7 199.2s-.1 0 0 0c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.7-1 5.4-1.5 8.2zM1637.1 185.5s-.1 0 0 0c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-.9 3-1.8 5.9-2.6 8.6zM1657.9 185.5c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1 3-1.7 5.9-2.6 8.6.1 0 .1 0 0 0zM1641.2 172.7c-.1-.1-.1-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c0-.1 0 0 0 0zM1661.3 172.7c0-.1 0-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c.1-.1.1 0 0 0zM1644.7 199.2c0-.1.4-2.5 1.1-5.9h.1v.1c-.7 3.3-1.1 5.7-1.2 5.8.1 0 .1 0 0 0zM1647.3 185.9c-.1 0-.1 0 0 0 1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.6 2.5-1.4 6.8-2.6 12.4zM1653.3 167.4c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1.2.2-2.7.9-4.1 2z'
                  />
                  <path
                    className='st78'
                    d='M1648.7 200.7s-.1 0 0 0c.1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.3-2.4 10.3-2.6 11.5zM1653.1 181.7c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0 .3-1.6.7-3.3 1.1-5h.1v.1c-.5 1.6-.9 3.2-1.2 4.9zM1655.4 172c-.1 0-.1 0 0 0 .4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.8.7-3.7 2.5-4.8 5.8zM1639.8 200.7c-.1 0-.1 0 0 0 0-.7.3-1.9.5-3.5h.1v.1c-.3 1.5-.5 2.7-.6 3.4zM1641.5 191.6s-.1 0 0 0c.3-1.7.7-3.4 1-5h.1v.1c-.3 1.5-.6 3.3-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_292'
                  x1={1645.44}
                  x2={1645.44}
                  y1={877.57}
                  y2={886.13}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='M1660.2 202.1v.3h-28.6c-.5-.5-.9-1.3-.9-2.3v-.1c.1-1.5 1.1-2.7 2.4-2.7.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5.3-.2.9-.2 1.4-.2 1.1 0 2.1.8 2.4 1.9.4.1.9.2 1.2.4.2-.7 1-1.2 1.7-1.2 1 0 1.9.8 1.9 1.9 0 .2 0 .4-.1.7.3-.1.7-.1 1-.1.5 0 1.1.1 1.5.4.8.4 1.5 1.1 2 1.7.6.5.8 1.2.8 1.9z'
                  fill='url(#svg_292)'
                />
                <path
                  className='st87'
                  d='M1633.5 202.4h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1 0 .3.1.7.3 1 0 .2.1.3.1.4zM1650.4 196.3c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.4 0 .8.1 1.3.2zM1653.6 198.7l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.3.3.5.7.6 1zM1652.6 200c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.1c.2-.3.3-.7.3-1 0-.5-.3-1.1-.8-1.4.1 0 .1.1.2.1.5.3.9.9.9 1.5 0 .3.2.5.5.5h4.6v-.3c0-.6.2-1.2.5-1.8 0-.1.1-.2.1-.2.1.1-.1.2-.1.2zM1644 200.7v.2c0 .5-.2 1.1-.4 1.5h-5.9c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1V200.1c-.1.1-.1.3-.1.6zM1635.4 198.7c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.6.3 1.1 1 1 1.5z'
                />
                <defs>
                  <path id='svg_291' d='M615-212.6h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_289' d='M612.8-214.8h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_290'>
                  <use overflow='visible' xlinkHref='#svg_291' />
                </clipPath>
                <clipPath id='svg_280'>
                  <use overflow='visible' xlinkHref='#svg_289' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={13.5}
                    id='svg_283'
                    width={35.1}
                    x={1628.1}
                    y={188.9}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={13.5}
                  id='svg_282'
                  maskUnits='userSpaceOnUse'
                  width={35.1}
                  x={1628.1}
                  y={188.9}>
                  <g filter='url(#svg_283)'>
                    <defs>
                      <path id='svg_288' d='M615-212.6h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_286' d='M612.8-214.8h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_287'>
                      <use overflow='visible' xlinkHref='#svg_288' />
                    </clipPath>
                    <clipPath id='svg_284'>
                      <use overflow='visible' xlinkHref='#svg_286' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_285'
                      x1={1645.66}
                      x2={1645.66}
                      y1={877.57}
                      y2={890.9}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_284)'
                      d='M1663.2 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4H1630c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.9 3.4 3.8z'
                      fill='url(#svg_285)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_281'
                  x1={1645.66}
                  x2={1645.66}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_280)'
                  d='M1663.2 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4H1630c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.9 3.4 3.8z'
                  fill='url(#svg_281)'
                  mask='url(#svg_282)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_279'
                  x1={1645.66}
                  x2={1645.66}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1663.2 199.2c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4H1630c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.9 3.4 3.8z'
                  enableBackground='new'
                  fill='url(#svg_279)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1634.5 194.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2zM1631.1 200.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zM1641.5 191.2c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1l.1-.1c.1 0 .1.1.1.1zM1637.7 191.8c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1648.6 193.6s-.1 0 0 0c-.1.1-.1 0-.1 0-.1 0 0-.1.1 0-.1-.1 0 0 0 0zM1651.3 194.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1646.1 191.8s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1639.4 193.2c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1629.1 198.7s-.1 0 0 0c-.1.1-.1 0-.1 0-.1-.1 0-.1.1 0-.1-.1 0-.1 0 0zM1634.1 192.2c-.1.1-.1 0-.1 0 0-.2 0-.2.1 0 0-.2 0-.2 0 0zM1633.4 196.5c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1652.1 192.9s-.1 0 0 0c-.1.1-.1 0-.1 0s0-.1.1 0c-.1-.1 0-.1 0 0zM1655.2 195s-.2.1 0 0c-.2.1-.2 0 0 0-.2 0-.2 0 0 0-.2 0 0 0 0 0zM1656.2 193.6s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1654.6 192.6c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0zM1656.6 196.4s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0z'
                  />
                  <circle className='st6' cx={1659.3} cy={196.3} r={0.1} />
                  <path
                    className='st6'
                    d='M1659.6 199c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1661.5 201c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1660.8 201.9c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_278'
                  x1={1661.7}
                  x2={1679.28}
                  y1={875.49}
                  y2={923.78}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_278)'
                  d='M1670.1 202.4h-14.2l15-44.1h14.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_277'
                  x1={1670.15}
                  x2={1691.12}
                  y1={899.63}
                  y2={899.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_277)'
                  d='M1691.2 158.3v44.1h-21.1l.9-2.4 14.1-41.7z'
                />
                <path
                  className='st6'
                  d='M1667.2 174.4h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1.1-.2-1.4-1.1-.9-2.6zm4.2 0c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-5.1-.6h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.9 0-3.6 1.5-4.6 3.9zm5-4-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.4.1-3.8-1.5-3.9zM1678.6 174.4h-1.6l-.1.2c.5.1.8.4.5 1-.3.9-1.2 1.4-2.4 1.4-1 0-1.7-.3-2.1-.9l-.9.9c.4.7 1.4 1 2.5 1 2.1 0 3.5-1.1 3.9-2.4.3-.6.4-1 .2-1.2zm-3.6-4.2-.4 1h3.8l-2.9 2.5v.1h1.2l.3-.2.2-.1 2.8-2.4.3-.8h-5.3v-.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_276'
                  x1={1670.84}
                  x2={1685.08}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_276)' d='M1670.9 148h14.2v10.4h-14.2z' />
                <path
                  className='st102'
                  d='M1683.6 155.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.2.3-.1.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_275'
                  x1={1671.88}
                  x2={1684.03}
                  y1={927.02}
                  y2={927.02}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1684.1 150.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_275)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1675.8 150.6-1.5 4.7h-1.4l1.7-4.7zM1683.2 150.6l-1.5 4.7h-3.3l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1684.1 152.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_274'
                  x1={1672.18}
                  x2={1672.18}
                  y1={924.69}
                  y2={929.43}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1672.4 155.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7c-.1 0-.1 0 0 0z'
                  fill='url(#svg_274)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_273'
                  x1={1701.1}
                  x2={1701.1}
                  y1={921.69}
                  y2={930.34}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_273)' d='M1686.5 149.7h29.2v8.6h-29.2z' />
                <path
                  className='st102'
                  d='M1715.5 156.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c0 .2-.2.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_272'
                  x1={1689.53}
                  x2={1689.53}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1691.8 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_272)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_271'
                  x1={1694.33}
                  x2={1694.33}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1696.6 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_271)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_270'
                  x1={1699.13}
                  x2={1699.13}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1701.4 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_270)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_269'
                  x1={1703.93}
                  x2={1703.93}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1706.2 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_269)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_268'
                  x1={1708.73}
                  x2={1708.73}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1711 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_268)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_267'
                  x1={1713.54}
                  x2={1713.54}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1715.8 150.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_267)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_266'
                  x1={1687.45}
                  x2={1687.45}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1687.7 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_266)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_265'
                  x1={1697.06}
                  x2={1697.06}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1697.3 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_265)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_264'
                  x1={1701.53}
                  x2={1701.53}
                  y1={923.8}
                  y2={926.39}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1687.2 153.6 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.7v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.8s0 .2 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.8 0s0 .2 0 0l4.5.1c.1 0 .1 0 .1-.1V154l-4.6.2v1.9zm4.8-2v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_264)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1696.3 150.4-2.7 5.9h-1.3l2.7-5.9zM1700.4 156.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1706.2 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c-.1-.1 0-.1 0 0zM1711 150.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0zM1714.2 150.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_263'
                  x1={1706.66}
                  x2={1706.66}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1706.9 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_263)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_262'
                  x1={1711.46}
                  x2={1711.46}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1711.7 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_262)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_261'
                  x1={1692.26}
                  x2={1692.26}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1692.5 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_261)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_260'
                  x1={1701.86}
                  x2={1701.86}
                  y1={923.8}
                  y2={929.66}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1702.1 156.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.2 0 0 0 0z'
                  fill='url(#svg_260)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_259'
                  x1={1703.61}
                  x2={1703.61}
                  y1={914.85}
                  y2={921.69}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={0.22} stopColor='#9FB4B9' />
                  <stop offset={0.49} stopColor='#ADC0C3' />
                  <stop offset={0.8} stopColor='#C4D5D6' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1716 158.3-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_259)'
                />
                <path
                  className='st80'
                  d='m1715.7 159.3-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1715.4 159.3-.1.4-2.4 7H1699V162c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1715.2 159.9-2.5 7.5h-10.4v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_258'
                  x1={1695.58}
                  x2={1695.58}
                  y1={877.59}
                  y2={916.81}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1714.3 163.2-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  fill='url(#svg_258)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_257'
                  x1={1676.82}
                  x2={1714.3}
                  y1={897.18}
                  y2={897.18}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1714.3 163.2-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  enableBackground='new'
                  fill='url(#svg_257)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1678.9 199.2c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.7-1 5.4-1.5 8.2.2 0 .2 0 0 0zM1699.3 199.2c-.1 0-.1 0 0 0 .3-2.8.9-5.6 1.4-8.3h.1v.1c-.6 2.7-1 5.4-1.5 8.2zM1681.8 185.5c-.1 0-.1 0 0 0 .7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1 3-1.9 5.9-2.6 8.6zM1702.5 185.5c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-.9 3-1.8 5.9-2.6 8.6.1 0 0 0 0 0zM1685.8 172.7s-.1 0 0 0c-.1-.1-.1-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c0-.1 0 0 0 0zM1705.9 172.7c0-.1 0-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c.1-.1 0 0 0 0zM1689.3 199.2c0-.1.4-2.5 1.1-5.9h.1v.1c-.6 3.3-1.1 5.7-1.2 5.8.1 0 0 0 0 0zM1691.9 185.9c-.1 0-.1 0 0 0 1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.6 2.5-1.5 6.8-2.6 12.4zM1697.8 167.4c0-.1 0-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1 .2-2.7.9-4.1 2 .1 0 .1 0 0 0z'
                  />
                  <path
                    className='st78'
                    d='M1693.3 200.7c-.1 0-.1 0 0 0 .1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.3-2.3 10.3-2.6 11.5zM1697.6 181.7s0-.1 0 0c.3-1.6.7-3.3 1.1-5h.1v.1c-.3 1.6-.8 3.2-1.2 4.9.1 0 .1 0 0 0zM1700 172c-.1 0-.1 0 0 0 .4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.7.7-3.7 2.5-4.8 5.8zM1684.3 200.7c0-.7.3-1.9.5-3.5h.1v.1c-.2 1.5-.4 2.7-.6 3.4.1 0 .1 0 0 0zM1686.1 191.6c-.1 0-.1 0 0 0 .3-1.7.7-3.4 1-5h.1v.1c-.3 1.5-.7 3.3-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_256'
                  x1={1688.49}
                  x2={1688.49}
                  y1={877.57}
                  y2={886.13}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='m1701.6 200-.8 2.4h-24.7c-.5-.5-.9-1.3-.9-2.3v-.1c.1-1.5 1.1-2.7 2.4-2.7.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5v5.3h10.7z'
                  fill='url(#svg_256)'
                />
                <path
                  className='st87'
                  d='M1678.2 202.4h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1 0 .3.1.7.3 1 0 .2 0 .3.1.4zM1695 196.3c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.4 0 .8.1 1.3.2zM1698.3 198.7l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.2.3.4.7.6 1zM1697.3 200c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.2c.2-.3.3-.7.3-1 0-.5-.3-1.1-.8-1.4.1 0 .1.1.2.1.5.3.9.9.9 1.5 0 .3.2.5.5.5h4.6v-.3c0-.6.1-1.2.6-1.8 0-.1.1-.2.1-.2-.1.1-.1.2-.1.2zM1688.7 200.7v.2c0 .5-.2 1.1-.4 1.5h-6c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1v.9zM1680 198.7c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.6.3 1 1 1 1.5z'
                />
                <defs>
                  <path id='svg_255' d='M615-212.6h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_253' d='M612.8-214.8h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_254'>
                  <use overflow='visible' xlinkHref='#svg_255' />
                </clipPath>
                <clipPath id='svg_244'>
                  <use overflow='visible' xlinkHref='#svg_253' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={13.7}
                    id='svg_247'
                    width={35.1}
                    x={1672.7}
                    y={188.7}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={13.7}
                  id='svg_246'
                  maskUnits='userSpaceOnUse'
                  width={35.1}
                  x={1672.7}
                  y={188.7}>
                  <g filter='url(#svg_247)'>
                    <defs>
                      <path id='svg_252' d='M615-212.6h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_250' d='M612.8-214.8h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_251'>
                      <use overflow='visible' xlinkHref='#svg_252' />
                    </clipPath>
                    <clipPath id='svg_248'>
                      <use overflow='visible' xlinkHref='#svg_250' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_249'
                      x1={1690.29}
                      x2={1690.29}
                      y1={877.57}
                      y2={890.9}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_248)'
                      d='M1707.9 199.2c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.8.5 3.5 2.2 3.5 4.1z'
                      fill='url(#svg_249)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_245'
                  x1={1690.29}
                  x2={1690.29}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_244)'
                  d='M1707.9 199.2c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.8.5 3.5 2.2 3.5 4.1z'
                  fill='url(#svg_245)'
                  mask='url(#svg_246)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_243'
                  x1={1690.29}
                  x2={1690.29}
                  y1={877.57}
                  y2={890.9}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1707.9 199.2c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.8.5 3.5 2.2 3.5 4.1z'
                  enableBackground='new'
                  fill='url(#svg_243)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1679.2 194.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c-.1-.1.2 0 .2.2z'
                  />
                  <circle className='st6' cx={1675.5} cy={200.2} r={0.2} />
                  <path
                    className='st6'
                    d='M1686.1 191.2c0 .1-.1.1-.1.1l-.1-.1.1-.1.1.1zM1682.3 191.8c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1693.1 193.6c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0 0 0 0zM1696 194.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1690.7 191.8s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1684.1 193.2c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1673.6 198.7c-.1.1-.1 0-.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0zM1678.7 192.2c-.1.1-.1 0-.1 0 0-.2 0-.2.1 0 0-.2 0-.2 0 0zM1678.1 196.5c0 .1-.1.1 0 0-.1.1-.1 0-.1 0h.1c-.1 0 0 0 0 0z'
                  />
                  <circle className='st6' cx={1696.6} cy={192.9} r={0.1} />
                  <circle className='st6' cx={1700.8} cy={193.6} r={0.1} />
                  <path
                    className='st6'
                    d='M1699.2 192.6s-.1 0 0 0c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0-.1-.1 0 0 0 0zM1701.2 196.4s0 .1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1704 196.3c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0-.1 0 0zM1704.3 199c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1706.1 201c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1705.5 201.9c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_242'
                  x1={1715.78}
                  x2={1730.02}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_242)' d='M1715.8 148h14.2v10.4h-14.2z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_241'
                  x1={1715.44}
                  x2={1715.44}
                  y1={877.59}
                  y2={921.67}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_241)'
                  d='M1730 158.3v44.1h-29.1l.7-2.4.6-1.6.9-2.5 12.7-37.6z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_240'
                  x1={1730.01}
                  x2={1743.35}
                  y1={899.63}
                  y2={899.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_240)' d='M1730 158.3h13.3v44.1H1730z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_239'
                  x1={1730.01}
                  x2={1743.35}
                  y1={926.86}
                  y2={926.86}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_239)' d='M1730 148h13.3v10.4H1730z' />
                <path
                  className='st102'
                  d='M1728.6 155.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.1.3-.2.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_238'
                  x1={1716.82}
                  x2={1728.97}
                  y1={927.02}
                  y2={927.02}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1728.9 150.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_238)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1720.7 150.6-1.5 4.7h-1.3l1.5-4.7zM1728.2 150.6l-1.6 4.7h-3.2l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1728.9 152.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_237'
                  x1={1717.03}
                  x2={1717.03}
                  y1={924.69}
                  y2={929.43}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1717.2 155.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7z'
                  fill='url(#svg_237)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_236'
                  x1={1733.01}
                  x2={1733.01}
                  y1={877.59}
                  y2={911.47}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.05} stopColor='#708EB0' />
                  <stop offset={0.13} stopColor='#819EBC' />
                  <stop offset={0.23} stopColor='#8EACC6' />
                  <stop offset={0.35} stopColor='#98B6CE' />
                  <stop offset={0.52} stopColor='#9EBCD2' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path fill='url(#svg_236)' d='M1727 168.6h12.1v33.8H1727z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_235'
                  x1={1743.38}
                  x2={1743.38}
                  y1={877.59}
                  y2={910.65}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.04} stopColor='#57789F' />
                  <stop offset={0.12} stopColor='#6987A8' />
                  <stop offset={0.22} stopColor='#7694B1' />
                  <stop offset={0.34} stopColor='#809EB8' />
                  <stop offset={0.51} stopColor='#86A4BB' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_235)' d='M1739.1 169.3h8.6v33.1h-8.6z' />
                <path
                  className='st102'
                  d='M1737.4 199.1h-8.9c-.5 0-.9-.4-.9-.9v-25.1c0-.5.4-.9.9-.9h8.9c.5 0 .9.4.9.9v25.1c.1.5-.3.9-.9.9z'
                />
                <path
                  className='st184'
                  d='M1728.5 198.9h-.4c-.1 0-.2-.1-.2-.2v-25.9c0-.1.1-.2.2-.2h.4c-.1 0-.2.1-.2.2v25.9c-.1 0 .1.2.2.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_234'
                  x1={1724.22}
                  x2={1742.26}
                  y1={885.27}
                  y2={903.31}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1738.2 172.7v25.9c0 .1-.1.2-.2.2h-9.4c-.1 0-.2-.1-.2-.2v-25.9c0-.1.1-.2.2-.2h9.4c0-.1.2 0 .2.2z'
                  fill='url(#svg_234)'
                />
                <path
                  className='st102'
                  d='M1727.8 174.1h10.4v.3h-10.4zM1727.8 178.7h10.4v.3h-10.4zM1727.8 183.2h10.4v.3h-10.4zM1727.8 187.8h10.4v.3h-10.4zM1727.8 192.3h10.4v.3h-10.4zM1727.8 196.8h10.4v.3h-10.4z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_233'
                  x1={1741.74}
                  x2={1741.74}
                  y1={910.65}
                  y2={911.45}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='M1747.9 169.3h-12.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h12.3c.2 0 .4.2.4.4s-.2.4-.4.4z'
                  fill='url(#svg_233)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_232'
                  x1={1732.9}
                  x2={1732.9}
                  y1={910.65}
                  y2={911.45}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='M1739.1 169.3h-12.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h12.3c.2 0 .4.2.4.4s-.2.4-.4.4z'
                  fill='url(#svg_232)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1731.9 172.4-3.7 11.6v-3.4l2.6-8.2zM1738.2 172.7v11.8l-4.5 14.4h-4.6l8.3-26.4h.4c.2-.1.4 0 .4.2z'
                  />
                </g>
                <defs>
                  <path id='svg_231' d='M615-212.6h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_229' d='M612.8-214.8h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_230'>
                  <use overflow='visible' xlinkHref='#svg_231' />
                </clipPath>
                <clipPath id='svg_220'>
                  <use overflow='visible' xlinkHref='#svg_229' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={0.8}
                    id='svg_223'
                    width={12.1}
                    x={1727}
                    y={169.3}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={0.8}
                  id='svg_222'
                  maskUnits='userSpaceOnUse'
                  width={12.1}
                  x={1727}
                  y={169.3}>
                  <g filter='url(#svg_223)'>
                    <defs>
                      <path id='svg_228' d='M615-212.6h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_226' d='M612.8-214.8h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_227'>
                      <use overflow='visible' xlinkHref='#svg_228' />
                    </clipPath>
                    <clipPath id='svg_224'>
                      <use overflow='visible' xlinkHref='#svg_226' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_225'
                      x1={1733.01}
                      x2={1733.01}
                      y1={910.65}
                      y2={909.93}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={0.12} stopColor='#C6C6C6' />
                      <stop offset={0.24} stopColor='#929292' />
                      <stop offset={0.37} stopColor='#656565' />
                      <stop offset={0.49} stopColor='#414141' />
                      <stop offset={0.62} stopColor='#242424' />
                      <stop offset={0.74} stopColor='#101010' />
                      <stop offset={0.87} stopColor='#040404' />
                      <stop offset={0.99} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_224)'
                      fill='url(#svg_225)'
                      d='M1727 169.3h12.1v.8H1727z'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_221'
                  x1={1733.01}
                  x2={1733.01}
                  y1={910.65}
                  y2={909.93}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.12} stopColor='#C6C6C6' />
                  <stop offset={0.24} stopColor='#929292' />
                  <stop offset={0.37} stopColor='#656565' />
                  <stop offset={0.49} stopColor='#414141' />
                  <stop offset={0.62} stopColor='#242424' />
                  <stop offset={0.74} stopColor='#101010' />
                  <stop offset={0.87} stopColor='#040404' />
                  <stop offset={0.99} />
                </linearGradient>
                <path
                  clipPath='url(#svg_220)'
                  fill='url(#svg_221)'
                  mask='url(#svg_222)'
                  d='M1727 169.3h12.1v.8H1727z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_219'
                  x1={1733.01}
                  x2={1733.01}
                  y1={910.65}
                  y2={909.93}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.05} stopColor='#53749C' />
                  <stop offset={0.29} stopColor='#6A88A9' />
                  <stop offset={0.52} stopColor='#7A98B3' />
                  <stop offset={0.76} stopColor='#84A2BA' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_219)' d='M1727 169.3h12.1v.8H1727z' />
                <defs>
                  <path id='svg_218' d='M615-212.6h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_216' d='M612.8-214.8h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_217'>
                  <use overflow='visible' xlinkHref='#svg_218' />
                </clipPath>
                <clipPath id='svg_207'>
                  <use overflow='visible' xlinkHref='#svg_216' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={0.8}
                    id='svg_210'
                    width={8.6}
                    x={1739.1}
                    y={169.3}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={0.8}
                  id='svg_209'
                  maskUnits='userSpaceOnUse'
                  width={8.6}
                  x={1739.1}
                  y={169.3}>
                  <g filter='url(#svg_210)'>
                    <defs>
                      <path id='svg_215' d='M615-212.6h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_213' d='M612.8-214.8h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_214'>
                      <use overflow='visible' xlinkHref='#svg_215' />
                    </clipPath>
                    <clipPath id='svg_211'>
                      <use overflow='visible' xlinkHref='#svg_213' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_212'
                      x1={1743.38}
                      x2={1743.38}
                      y1={910.65}
                      y2={909.93}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={0.12} stopColor='#C6C6C6' />
                      <stop offset={0.24} stopColor='#929292' />
                      <stop offset={0.37} stopColor='#656565' />
                      <stop offset={0.49} stopColor='#414141' />
                      <stop offset={0.62} stopColor='#242424' />
                      <stop offset={0.74} stopColor='#101010' />
                      <stop offset={0.87} stopColor='#040404' />
                      <stop offset={0.99} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_211)'
                      fill='url(#svg_212)'
                      d='M1739.1 169.3h8.6v.8h-8.6z'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_208'
                  x1={1743.38}
                  x2={1743.38}
                  y1={910.65}
                  y2={909.93}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.12} stopColor='#C6C6C6' />
                  <stop offset={0.24} stopColor='#929292' />
                  <stop offset={0.37} stopColor='#656565' />
                  <stop offset={0.49} stopColor='#414141' />
                  <stop offset={0.62} stopColor='#242424' />
                  <stop offset={0.74} stopColor='#101010' />
                  <stop offset={0.87} stopColor='#040404' />
                  <stop offset={0.99} />
                </linearGradient>
                <path
                  clipPath='url(#svg_207)'
                  fill='url(#svg_208)'
                  mask='url(#svg_209)'
                  d='M1739.1 169.3h8.6v.8h-8.6z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_206'
                  x1={1743.38}
                  x2={1743.38}
                  y1={910.65}
                  y2={909.93}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.05} stopColor='#53749C' />
                  <stop offset={0.29} stopColor='#6A88A9' />
                  <stop offset={0.52} stopColor='#7A98B3' />
                  <stop offset={0.76} stopColor='#84A2BA' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_206)' d='M1739.1 169.3h8.6v.8h-8.6z' />
                <path
                  className='st202'
                  d='M1728.6 166v.3c0 .4-.3.8-.8.8h-2c-1.2 0-2.1 1-2.1 2.1v33.4h-1.5V169c0-1.5 1.2-2.7 2.7-2.7h3.3c.2-.2.3-.2.4-.3zM1721.4 166.1c0 .1-.1.1-.1.1-.5.8-.9 1.6-.9 2.6V202.5h-1.5v-33.6c.1-1.5 1.1-2.6 2.5-2.8zM1718.1 166.1c0 .1-.1.1-.1.1-.5.8-.9 1.6-.9 2.6V202.5h-1.5v-33.6c.1-1.5 1.1-2.6 2.5-2.8z'
                />
                <path
                  className='st203'
                  d='M1722.2 165.2c0 .5-.3.9-.7.9h-2.9c-1.5 0-2.7 1.2-2.7 2.7v33.6h-1.9v-33.6c0-2.5 2.1-4.6 4.6-4.6h2.9c.3 0 .7.5.7 1z'
                />
                <path
                  className='st203'
                  d='M1725.4 165.2c0 .5-.3.9-.7.9h-2.9c-1.5 0-2.7 1.2-2.7 2.7v33.6h-1.9v-33.6c0-2.5 2.1-4.6 4.6-4.6h2.9c.4 0 .7.5.7 1z'
                />
                <path
                  className='st204'
                  d='M1721.7 165.6c-.1.1-.2.3-.3.4-1.3.2-2.4 1.3-2.4 2.7v33.6h-.5v-33.7c0-1.7 1.4-3.1 3.1-3.1h.1v.1zM1718.4 165.6c-.1.1-.2.3-.3.4-1.3.2-2.4 1.3-2.4 2.7v33.6h-.5v-33.7c0-1.7 1.4-3.1 3.1-3.1h.1v.1z'
                />
                <path
                  className='st203'
                  d='M1721.9 165.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V168.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1717c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.4-.2.4-.1.4.2 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_205'
                  x1={1721.29}
                  x2={1722.27}
                  y1={914.67}
                  y2={914.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 165.2c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.6-.5 1 0 1 .5z'
                  fill='url(#svg_205)'
                />
                <path
                  className='st204'
                  d='M1721.8 165.6c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_204'
                  x1={1714.68}
                  x2={1714.68}
                  y1={907.58}
                  y2={907.88}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 172.4h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1-.1.1-.1.1z'
                  fill='url(#svg_204)'
                />
                <path className='st204' d='M1713.8 172.4h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_203'
                  x1={1714.68}
                  x2={1714.68}
                  y1={902.02}
                  y2={902.32}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 178h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1-.1.1-.1.1z'
                  fill='url(#svg_203)'
                />
                <path className='st204' d='M1713.8 178h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_202'
                  x1={1714.68}
                  x2={1714.68}
                  y1={896.46}
                  y2={896.76}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 183.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_202)'
                />
                <path className='st204' d='M1713.8 183.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_201'
                  x1={1714.68}
                  x2={1714.68}
                  y1={890.91}
                  y2={891.21}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 189.1h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_201)'
                />
                <path className='st204' d='M1713.8 189.1h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_200'
                  x1={1714.68}
                  x2={1714.68}
                  y1={885.35}
                  y2={885.65}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 194.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_200)'
                />
                <path className='st204' d='M1713.8 194.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_199'
                  x1={1714.68}
                  x2={1714.68}
                  y1={879.8}
                  y2={880.1}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1715.6 200.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_199)'
                />
                <path className='st204' d='M1713.8 200.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_198'
                  x1={3112.01}
                  x2={3112.01}
                  y1={456.41}
                  y2={456.71}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1715.6 168.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2s-.1.1-.2.1z'
                  fill='url(#svg_198)'
                />
                <path
                  className='st204'
                  d='M1715.6 168.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1717.6 166.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.2.1.3.6.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_197'
                  x1={1717.04}
                  x2={1717.88}
                  y1={914.73}
                  y2={914.73}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1717.7 166.3c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1 0-.2.1-.2.1z'
                  fill='url(#svg_197)'
                />
                <path
                  className='st203'
                  d='M1725.3 165.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V168.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1720.4c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.3-.2.4-.1.4.2 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_196'
                  x1={1724.64}
                  x2={1725.62}
                  y1={914.67}
                  y2={914.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.6 165.2c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.7-.5 1 0 1 .5z'
                  fill='url(#svg_196)'
                />
                <path
                  className='st204'
                  d='M1725.2 165.6c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_195'
                  x1={1717.98}
                  x2={1717.98}
                  y1={907.58}
                  y2={907.88}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 172.4h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1.1 0 .1-.1.1z'
                  fill='url(#svg_195)'
                />
                <path className='st204' d='M1717.1 172.4h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_194'
                  x1={1717.98}
                  x2={1717.98}
                  y1={902.02}
                  y2={902.32}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 178h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1.1 0 .1-.1.1z'
                  fill='url(#svg_194)'
                />
                <path className='st204' d='M1717.1 178h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_193'
                  x1={1717.98}
                  x2={1717.98}
                  y1={896.46}
                  y2={896.76}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 183.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_193)'
                />
                <path className='st204' d='M1717.1 183.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_192'
                  x1={1717.98}
                  x2={1717.98}
                  y1={890.91}
                  y2={891.21}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 189.1h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_192)'
                />
                <path className='st204' d='M1717.1 189.1h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_191'
                  x1={1717.98}
                  x2={1717.98}
                  y1={885.35}
                  y2={885.65}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 194.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_191)'
                />
                <path className='st204' d='M1717.1 194.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_190'
                  x1={1717.98}
                  x2={1717.98}
                  y1={879.8}
                  y2={880.1}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.9 200.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_190)'
                />
                <path className='st204' d='M1717.1 200.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_189'
                  x1={3115.29}
                  x2={3115.29}
                  y1={457.2}
                  y2={457.5}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1719 168.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2-.1.1-.1.1-.2.1z'
                  fill='url(#svg_189)'
                />
                <path
                  className='st204'
                  d='M1719 168.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1721 166.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.2.1.3.6.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_188'
                  x1={1720.39}
                  x2={1721.23}
                  y1={914.73}
                  y2={914.73}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1721 166.3c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1 0-.1.1-.2.1z'
                  fill='url(#svg_188)'
                />
                <path
                  className='st203'
                  d='M1728.7 165.2c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V168.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1723.8c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.3-.2.3-.1.4.2 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_187'
                  x1={1727.98}
                  x2={1728.96}
                  y1={914.67}
                  y2={914.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1728.9 165.2c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.8-.5 1 0 1 .5z'
                  fill='url(#svg_187)'
                />
                <path
                  className='st204'
                  d='M1728.6 165.6c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_186'
                  x1={1721.34}
                  x2={1721.34}
                  y1={907.58}
                  y2={907.88}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 172.4h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z'
                  fill='url(#svg_186)'
                />
                <path className='st204' d='M1720.4 172.4h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_185'
                  x1={1721.34}
                  x2={1721.34}
                  y1={902.02}
                  y2={902.32}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 178h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z'
                  fill='url(#svg_185)'
                />
                <path className='st204' d='M1720.4 178h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_184'
                  x1={1721.34}
                  x2={1721.34}
                  y1={896.46}
                  y2={896.76}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 183.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_184)'
                />
                <path className='st204' d='M1720.4 183.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_183'
                  x1={1721.34}
                  x2={1721.34}
                  y1={890.91}
                  y2={891.21}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 189.1h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_183)'
                />
                <path className='st204' d='M1720.4 189.1h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_182'
                  x1={1721.34}
                  x2={1721.34}
                  y1={885.35}
                  y2={885.65}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 194.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_182)'
                />
                <path className='st204' d='M1720.4 194.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_181'
                  x1={1721.34}
                  x2={1721.34}
                  y1={879.8}
                  y2={880.1}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.3 200.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_181)'
                />
                <path className='st204' d='M1720.4 200.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_180'
                  x1={3118.58}
                  x2={3118.58}
                  y1={457.98}
                  y2={458.29}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1722.4 168.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2-.1.1-.2.1-.2.1z'
                  fill='url(#svg_180)'
                />
                <path
                  className='st204'
                  d='M1722.3 168.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1724.3 166.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.1.1.4.6.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_179'
                  x1={1723.73}
                  x2={1724.57}
                  y1={914.73}
                  y2={914.73}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1724.3 166.3c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1 0-.1.1-.2.1z'
                  fill='url(#svg_179)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_178'
                  x1={1629.51}
                  x2={1629.51}
                  y1={877.57}
                  y2={879.95}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.61} stopColor='#6BA4CE' />
                  <stop offset={1} stopColor='#DCEFFB' />
                </linearGradient>
                <path
                  d='m1701.6 200-.8 2.4h-142.5c-.5 0-1-.4-1-1 0-.8.7-1.3 1.3-1.3h143v-.1z'
                  fill='url(#svg_178)'
                />
                <path
                  className='st4'
                  d='M1716.8 713.4h-119.9c-24.8 0-45-20.1-45-45v-51.7c0-24.8 20.1-45 45-45h119.8c24.8 0 45 20.1 45 45v51.7c-.1 24.8-20.2 45-44.9 45z'
                />
                <text
                  className='st6 st7 st8'
                  transform='translate(1587.285 679.389)'>
                  {"Andijon Suv Ombori"}
                </text>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_177'
                  x1={1591.54}
                  x2={1591.54}
                  y1={470.63}
                  y2={480.96}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_177)' d='M1584.4 599h14.2v10.4h-14.2z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_176'
                  x1={1579.24}
                  x2={1588.84}
                  y1={434.57}
                  y2={462.1}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_176)'
                  d='M1583.8 653.5h-14.2l14.8-44.1h14.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_175'
                  x1={1583.82}
                  x2={1604.77}
                  y1={448.57}
                  y2={448.57}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_175)'
                  d='M1604.7 609.4v44.1h-20.9l.9-2.4 14-41.7z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_174'
                  x1={1598.74}
                  x2={1604.79}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_174)' d='M1598.7 599h6v10.4h-6z' />
                <path
                  className='st6'
                  d='M1586.2 625.5c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-.1-4.4-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.4.2-3.8-1.5-3.9zm-5 3.9h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.9.1-3.7 1.5-4.6 3.9zm.9.5h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1-.1-1.4-.9-.9-2.6zM1589.8 625.5l-1.4 3.6h1.1l1.4-3.6h-1.1zm-.1-4.4-.4 1h1.9l-1.1 2.9h1.1l1.5-3.9h-3z'
                />
                <path
                  className='st78'
                  d='M1602.1 631.5c0-.1-.1-.1 0 0 .7-3.2 1.2-5.7 1.6-7.4h.1v.1c-.4 1.7-1 4.2-1.7 7.3 0-.1 0 0 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_173'
                  x1={1617.29}
                  x2={1617.29}
                  y1={463.79}
                  y2={470.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1629.7 609.4-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_173)'
                />
                <path
                  className='st80'
                  d='m1629.4 610.4-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1629.1 610.4-.1.4-2.4 7h-13.9v-4.7c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1628.9 610.9-2.5 7.5H1616v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_172'
                  x1={1609.33}
                  x2={1609.33}
                  y1={426.53}
                  y2={465.75}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1628 614.3-11.1 32.5-.9 2.5-.5 1.7-.8 2.4h-24c0-.8 0-1.5.1-2.4.1-.9.2-1.7.3-2.7.4-2.3 1-4.8 1.7-7.2 1.7-6 4.1-12 5.7-16.9 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3h15.9z'
                  fill='url(#svg_172)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_171'
                  x1={1590.48}
                  x2={1627.96}
                  y1={446.12}
                  y2={446.12}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1628 614.3-11.1 32.5-.9 2.5-.5 1.7-.8 2.4h-24c0-.8 0-1.5.1-2.4.1-.9.2-1.7.3-2.7.4-2.3 1-4.8 1.7-7.2 1.7-6 4.1-12 5.7-16.9 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3h15.9z'
                  enableBackground='new'
                  fill='url(#svg_171)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1592.6 650.3c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.6-1 5.4-1.5 8.2.1 0 0 0 0 0zM1613 650.3c-.1 0-.1 0 0 0 .3-2.8.9-5.6 1.4-8.3h.1v.1c-.6 2.6-1 5.4-1.5 8.2zM1595.5 636.6c-.1 0-.1 0 0 0 .7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1.1 3-1.9 5.8-2.6 8.6zM1616.2 636.6s-.1 0 0 0c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1 3-1.8 5.8-2.6 8.6zM1599.4 623.8c0-.1 0-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c.1-.1.1 0 0 0zM1619.6 623.8c-.1-.1-.1-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c0-.1 0 0 0 0zM1603 650.3s-.1 0 0 0c0-.1.4-2.5 1.1-5.9h.1v.1c-.7 3.3-1.2 5.7-1.2 5.8zM1605.5 637c1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.5 2.5-1.4 6.7-2.6 12.4.1 0 .1 0 0 0zM1611.5 618.4c0-.1 0-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1 .3-2.7 1-4.1 2z'
                  />
                  <path
                    className='st78'
                    d='M1607 651.7c-.1 0-.1 0 0 0 .1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.4-2.3 10.3-2.6 11.5zM1611.3 632.7s0-.1 0 0c.3-1.6.7-3.3 1.1-5h.1v.1c-.3 1.7-.8 3.3-1.2 4.9.1 0 0 0 0 0zM1613.6 623c.4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.7.8-3.6 2.6-4.8 5.8.1 0 .1 0 0 0zM1598 651.7c0-.7.3-1.9.5-3.5h.1v.1c-.2 1.6-.4 2.8-.6 3.4.1 0 0 0 0 0zM1599.8 642.7c-.1 0-.1 0 0 0 .3-1.7.7-3.4 1-5h.1v.1c-.4 1.5-.7 3.2-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_170'
                  x1={1603.76}
                  x2={1603.76}
                  y1={426.51}
                  y2={435.07}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='M1618.5 653.1v.3h-28.6c-.5-.5-.9-1.3-.9-2.3v-.1c0-1.3.9-2.5 2-2.7h.4c.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5.3-.2.9-.2 1.4-.2 1.1 0 2.1.8 2.4 1.9.4.1.9.2 1.2.4.2-.7 1-1.2 1.7-1.2 1 0 1.9.8 1.9 1.9 0 .2 0 .4-.1.7.3-.1.7-.1 1-.1.5 0 1.1.1 1.5.4h.2c.8.4 1.4 1 1.9 1.7.4.5.7 1.3.7 1.9z'
                  fill='url(#svg_170)'
                />
                <path
                  className='st87'
                  d='M1591.9 653.5h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1s.1.7.3 1c0 .2 0 .3.1.4zM1608.6 647.4c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.5-.1.9.1 1.3.2zM1611.9 649.8l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.2.3.4.6.6 1zM1610.9 651.1c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.1c0-.1.1-.1.1-.2.1-.2.2-.4.2-.8 0-.2-.1-.5-.2-.8s-.3-.4-.5-.7c.1 0 .1.1.2.1l.3.3c.3.3.5.8.5 1.2 0 .3.2.5.5.5h4.6v-.3c0-.5.1-1.2.5-1.7 0-.1.1-.2.1-.2 0 .1 0 .2-.1.2zM1602.3 651.7v.2c0 .5-.2 1.1-.4 1.5h-6c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1v.9zM1593.7 649.8c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.6.3 1 .9 1 1.5z'
                />
                <defs>
                  <path id='svg_169' d='M618.2 238.5h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_167' d='M616 236.3h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_168'>
                  <use overflow='visible' xlinkHref='#svg_169' />
                </clipPath>
                <clipPath id='svg_158'>
                  <use overflow='visible' xlinkHref='#svg_167' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={13.5}
                    id='svg_161'
                    width={35}
                    x={1586.4}
                    y={639.9}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={13.5}
                  id='svg_160'
                  maskUnits='userSpaceOnUse'
                  width={35}
                  x={1586.4}
                  y={639.9}>
                  <g filter='url(#svg_161)'>
                    <defs>
                      <path id='svg_166' d='M618.2 238.5h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_164' d='M616 236.3h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_165'>
                      <use overflow='visible' xlinkHref='#svg_166' />
                    </clipPath>
                    <clipPath id='svg_162'>
                      <use overflow='visible' xlinkHref='#svg_164' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_163'
                      x1={1603.93}
                      x2={1603.93}
                      y1={426.51}
                      y2={439.84}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_162)'
                      d='M1621.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.7.1 3.2 1.7 3.2 3.7z'
                      fill='url(#svg_163)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_159'
                  x1={1603.93}
                  x2={1603.93}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_158)'
                  d='M1621.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.7.1 3.2 1.7 3.2 3.7z'
                  fill='url(#svg_159)'
                  mask='url(#svg_160)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_157'
                  x1={1603.93}
                  x2={1603.93}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1621.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.4 1.6-4.5 3.8-5.1.4-.1 1-.2 1.5-.2 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.2c.3-.1.7-.1 1.1-.1 1.7.1 3.2 1.7 3.2 3.7z'
                  enableBackground='new'
                  fill='url(#svg_157)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1592.7 645.4c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2zM1589.4 651.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0 0 .2.1.2.2zM1599.8 642.2c0 .1-.1.1-.1.1l-.1-.1c0-.1.1-.1.1-.1l.1.1zM1596 642.9c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1606.8 644.6c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0 0 0 0zM1609.7 645.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1604.4 642.9s0 .1 0 0c-.1.1-.2 0-.2 0 0-.1.1-.1.2 0 0-.1 0-.1 0 0zM1597.8 644.3c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1587.3 649.8c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1592.4 643.2s-.1 0 0 0c-.1.1-.1 0-.1 0-.1-.1 0-.1.1 0-.1-.1 0-.1 0 0zM1591.6 647.6c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1610.3 644c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1613.4 646.1s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0zM1614.6 644.6s0 .1 0 0c-.1.1-.2 0-.2 0-.1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1614.9 647.5s0 .1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1617.7 647.4s-.1 0 0 0c-.1.1-.1 0-.1 0-.1-.1 0-.1.1 0-.1-.1 0-.1 0 0zM1617.9 650.1c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1619.8 652.1c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1619.1 652.9c0 .1-.1.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_156'
                  x1={1636.5}
                  x2={1636.5}
                  y1={470.63}
                  y2={480.96}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_156)' d='M1629.4 599h14.2v10.4h-14.2z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_155'
                  x1={1620.28}
                  x2={1637.86}
                  y1={424.41}
                  y2={472.7}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_155)'
                  d='m1643.6 609.4-14.1 41.7-.7 2.4h-14.3l.7-2.4.7-1.8.8-2.4 9.7-28.6.1-.4 2.4-7 .2-.5.3-1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_154'
                  x1={1628.71}
                  x2={1649.66}
                  y1={448.57}
                  y2={448.57}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_154)'
                  d='M1649.7 609.4v44.1h-20.9l.7-2.4 14.1-41.7z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_153'
                  x1={1643.63}
                  x2={1649.68}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_153)' d='M1643.6 599h6v10.4h-6z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_152'
                  x1={1688.24}
                  x2={1694.29}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_152)' d='M1688.2 599h6v10.4h-6z' />
                <path
                  className='st6'
                  d='m1629.8 621.1-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.4.2-3.8-1.5-3.9zm-5.1 3.9h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.7.1-3.6 1.5-4.6 3.9zm5.3.5c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-4.3 0h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1-.1-1.3-.9-.9-2.6zM1636.4 621c-1.2 0-2.5.4-3.4 1.2l.5.7c.8-.5 1.5-.9 2.4-.9 1.1 0 1.5.5 1.2 1.3-.2.4-.5 1-1.5 1.6h1.3c.8-.7 1.1-1.2 1.3-1.7.6-1.4-.1-2.2-1.8-2.2zm-3.7 7 3.4-2.4c.1-.1.2-.1.3-.2h-1.4l-3.9 2.7-.3.8h5.8l.4-1h-4.3v.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_151'
                  x1={1614.78}
                  x2={1614.78}
                  y1={470.63}
                  y2={479.28}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_151)' d='M1600.2 600.8h29.2v8.6h-29.2z' />
                <path
                  className='st102'
                  d='M1629.1 607.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c0 .2-.1.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_150'
                  x1={1603.11}
                  x2={1603.11}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1605.4 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_150)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_149'
                  x1={1607.91}
                  x2={1607.91}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1610.2 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_149)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_148'
                  x1={1612.71}
                  x2={1612.71}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1615 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_148)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_147'
                  x1={1617.51}
                  x2={1617.51}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1619.8 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_147)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_146'
                  x1={1622.31}
                  x2={1622.31}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1624.6 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_146)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_145'
                  x1={1627.11}
                  x2={1627.11}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1629.4 601.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_145)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_144'
                  x1={1601.03}
                  x2={1601.03}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1601.3 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.2-.1 0 0 0 0z'
                  fill='url(#svg_144)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_143'
                  x1={1610.64}
                  x2={1610.64}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1610.9 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.2-.1 0 0 0 0z'
                  fill='url(#svg_143)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_142'
                  x1={1615.11}
                  x2={1615.11}
                  y1={472.74}
                  y2={475.33}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1600.8 604.7 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.6v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.9s0 .1 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.8 0s0 .1 0 0l4.5.1c.1 0 .1 0 .1-.1v-2.1l-4.6.2v1.9zm4.8-2.1v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_142)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1609.9 601.4-2.8 5.9h-1.3l2.9-5.9zM1614.1 607.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1619.8 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c-.1-.1 0-.1 0 0zM1624.6 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0zM1627.8 601.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_141'
                  x1={1620.24}
                  x2={1620.24}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1620.5 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.2-.1 0 0 0 0z'
                  fill='url(#svg_141)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_140'
                  x1={1625.04}
                  x2={1625.04}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1625.3 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_140)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_139'
                  x1={1605.89}
                  x2={1605.89}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1606.2 607.3h-.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.2 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_139)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_138'
                  x1={1615.44}
                  x2={1615.44}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1615.7 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.2-.1 0 0 0 0z'
                  fill='url(#svg_138)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_137'
                  x1={1659.63}
                  x2={1659.63}
                  y1={470.63}
                  y2={479.28}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_137)' d='M1645 600.8h29.2v8.6H1645z' />
                <path
                  className='st102'
                  d='M1674 607.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c0 .2-.2.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_136'
                  x1={1647.96}
                  x2={1647.96}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1650.2 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_136)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_135'
                  x1={1652.76}
                  x2={1652.76}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1655 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_135)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_134'
                  x1={1657.56}
                  x2={1657.56}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1659.9 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_134)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_133'
                  x1={1662.36}
                  x2={1662.36}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1664.7 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_133)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_132'
                  x1={1667.16}
                  x2={1667.16}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1669.5 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_132)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_131'
                  x1={1671.96}
                  x2={1671.96}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1674.3 601.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_131)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_130'
                  x1={1645.99}
                  x2={1645.99}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1646.2 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_130)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_129'
                  x1={1655.6}
                  x2={1655.6}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1655.8 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_129)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_128'
                  x1={1659.96}
                  x2={1659.96}
                  y1={472.74}
                  y2={475.33}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1645.7 604.7 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.6v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.9s.1.1 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.8 0s.1.1 0 0l4.5.1c.1 0 .1 0 .1-.1v-2.1l-4.6.2v1.9zm4.8-2.1v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_128)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1654.8 601.4-2.7 5.9h-1.3l2.7-5.9zM1659 607.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1664.7 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c0-.1 0-.1 0 0zM1669.5 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c0-.1 0-.1 0 0zM1672.6 601.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_127'
                  x1={1665.2}
                  x2={1665.2}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1665.4 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_127)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_126'
                  x1={1670}
                  x2={1670}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1670.2 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_126)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_125'
                  x1={1650.79}
                  x2={1650.79}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1651 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_125)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_124'
                  x1={1660.4}
                  x2={1660.4}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1660.6 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1-.1 0 0 0z'
                  fill='url(#svg_124)'
                />
                <path
                  className='st102'
                  d='M1597.3 606.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.1.3-.1.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_123'
                  x1={1585.55}
                  x2={1597.7}
                  y1={475.96}
                  y2={475.96}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1597.7 601.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_123)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1589.5 601.6-1.6 4.7h-1.3l1.6-4.7zM1596.9 601.6l-1.5 4.7h-3.3l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1597.7 603.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_122'
                  x1={1585.76}
                  x2={1585.76}
                  y1={473.63}
                  y2={478.37}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1586 606.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7z'
                  fill='url(#svg_122)'
                />
                <path
                  className='st102'
                  d='M1642.3 606.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c0 .3-.3.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_121'
                  x1={1630.44}
                  x2={1642.58}
                  y1={475.96}
                  y2={475.96}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1642.6 601.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_121)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1634.3 601.6-1.5 4.7h-1.2l1.5-4.7zM1641.7 601.6l-1.5 4.7h-3.2l1.6-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1642.6 603.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_120'
                  x1={1630.72}
                  x2={1630.72}
                  y1={473.63}
                  y2={478.37}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1630.9 606.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7c-.1 0-.1 0 0 0z'
                  fill='url(#svg_120)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_119'
                  x1={1662.14}
                  x2={1662.14}
                  y1={463.79}
                  y2={470.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1674.6 609.4-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_119)'
                />
                <path
                  className='st80'
                  d='m1674.3 610.4-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1673.9 610.4-.1.4-2.4 7h-13.9v-4.7c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1673.8 610.9-2.5 7.5h-10.4v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_118'
                  x1={1654.12}
                  x2={1654.12}
                  y1={426.53}
                  y2={465.75}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1672.8 614.3-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  fill='url(#svg_118)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_117'
                  x1={1635.41}
                  x2={1672.89}
                  y1={446.12}
                  y2={446.12}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1672.8 614.3-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  enableBackground='new'
                  fill='url(#svg_117)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1637.5 650.3c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.6-1 5.4-1.5 8.2.1 0 .1 0 0 0zM1657.9 650.3s-.1 0 0 0c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.6-1.1 5.4-1.5 8.2zM1640.3 636.6s-.1 0 0 0c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-.9 3-1.8 5.8-2.6 8.6zM1661.1 636.6c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1 3-1.8 5.8-2.6 8.6.1 0 .1 0 0 0zM1644.4 623.8c-.2-.1-.2-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c0-.1 0 0 0 0zM1664.4 623.8c0-.1 0-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c.1-.1.1 0 0 0zM1647.8 650.3c0-.1.4-2.5 1.1-5.9h.1v.1c-.6 3.3-1 5.7-1.2 5.8.2 0 .2 0 0 0zM1650.5 637c-.1 0-.1 0 0 0 1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.7 2.5-1.4 6.7-2.6 12.4zM1656.5 618.4c-.1 0-.1 0 0 0-.1-.1-.1-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1.2.3-2.7 1-4.1 2z'
                  />
                  <path
                    className='st78'
                    d='M1651.9 651.7s-.1 0 0 0c.1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.4-2.4 10.3-2.6 11.5zM1656.2 632.7c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0 .3-1.6.7-3.3 1.1-5h.1v.1c-.4 1.7-.8 3.3-1.2 4.9zM1658.5 623c-.1 0-.1 0 0 0 .4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.7.8-3.7 2.6-4.8 5.8zM1642.9 651.7c-.1 0-.1 0 0 0 0-.7.3-1.9.5-3.5h.1v.1c-.2 1.6-.5 2.8-.6 3.4zM1644.7 642.7s-.1 0 0 0c.3-1.7.7-3.4 1-5h.1v.1c-.4 1.5-.7 3.2-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_116'
                  x1={1648.61}
                  x2={1648.61}
                  y1={426.51}
                  y2={435.07}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='M1663.3 653.1v.3h-28.6c-.5-.5-.9-1.3-.9-2.3v-.1c.1-1.5 1.1-2.7 2.4-2.7.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5.3-.2.9-.2 1.4-.2 1.1 0 2.1.8 2.4 1.9.4.1.9.2 1.2.4.2-.7 1-1.2 1.7-1.2 1 0 1.9.8 1.9 1.9 0 .2 0 .4-.1.7.3-.1.7-.1 1-.1.5 0 1.1.1 1.5.4.8.4 1.5 1.1 2 1.7.6.5.8 1.3.8 1.9z'
                  fill='url(#svg_116)'
                />
                <path
                  className='st87'
                  d='M1636.7 653.5h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1s.1.7.3 1c0 .2.1.3.1.4zM1653.5 647.4c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.4-.1.9.1 1.3.2zM1656.8 649.8l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.3.3.5.6.6 1zM1655.8 651.1c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.1c.2-.3.3-.7.3-1 0-.5-.3-1.1-.8-1.4.1 0 .1.1.2.1.5.3.9.9.9 1.5 0 .3.2.5.5.5h4.6v-.3c0-.6.2-1.3.5-1.8 0-.1.1-.2.1-.2 0 .1-.1.2-.1.2zM1647.2 651.7v.2c0 .5-.2 1.1-.4 1.5h-5.9c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1V651.1c-.1.2-.1.4-.1.6zM1638.6 649.8c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.5.3 1.1.9 1 1.5z'
                />
                <defs>
                  <path id='svg_115' d='M618.2 238.5h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_113' d='M616 236.3h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_114'>
                  <use overflow='visible' xlinkHref='#svg_115' />
                </clipPath>
                <clipPath id='svg_104'>
                  <use overflow='visible' xlinkHref='#svg_113' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={13.5}
                    id='svg_107'
                    width={35.1}
                    x={1631.3}
                    y={639.9}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={13.5}
                  id='svg_106'
                  maskUnits='userSpaceOnUse'
                  width={35.1}
                  x={1631.3}
                  y={639.9}>
                  <g filter='url(#svg_107)'>
                    <defs>
                      <path id='svg_112' d='M618.2 238.5h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_110' d='M616 236.3h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_111'>
                      <use overflow='visible' xlinkHref='#svg_112' />
                    </clipPath>
                    <clipPath id='svg_108'>
                      <use overflow='visible' xlinkHref='#svg_110' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_109'
                      x1={1648.83}
                      x2={1648.83}
                      y1={426.51}
                      y2={439.84}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_108)'
                      d='M1666.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.4c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.8 3.4 3.8z'
                      fill='url(#svg_109)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_105'
                  x1={1648.83}
                  x2={1648.83}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_104)'
                  d='M1666.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.4c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.8 3.4 3.8z'
                  fill='url(#svg_105)'
                  mask='url(#svg_106)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_103'
                  x1={1648.83}
                  x2={1648.83}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1666.4 650.3c0 .2 0 .5-.1.8-.2 1-.9 1.9-1.7 2.4h-31.4c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4 .3-.1.8-.2 1.2-.2 1.8.2 3.4 1.8 3.4 3.8z'
                  enableBackground='new'
                  fill='url(#svg_103)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1637.7 645.4c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2 0 .2.2zM1634.3 651.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zM1644.7 642.2c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1l.1-.1c.1 0 .1.1.1.1zM1640.9 642.9c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1651.8 644.6s-.1 0 0 0c-.1.1-.1 0-.1 0-.1 0 0-.1.1 0-.1-.1 0 0 0 0zM1654.5 645.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1649.3 642.9s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1642.6 644.3c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1632.2 649.8s-.1 0 0 0c-.1.1-.1 0-.1 0-.1-.1 0-.1.1 0-.1-.1 0-.1 0 0zM1637.3 643.2c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1636.6 647.6c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1655.3 644s-.1 0 0 0c-.1.1-.1 0-.1 0s0-.1.1 0c-.1-.1 0-.1 0 0zM1658.3 646.1s-.1.1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0-.1 0 0 0 0 0zM1659.4 644.6s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1657.8 643.6c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0 0-.1 0 0 0 0zM1659.7 647.5s0 .1 0 0c0 .1-.1 0 0 0-.1 0 0 0 0 0z'
                  />
                  <circle className='st6' cx={1662.5} cy={647.4} r={0.1} />
                  <path
                    className='st6'
                    d='M1662.8 650.1c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1664.7 652.1c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1664 652.9c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_102'
                  x1={1664.87}
                  x2={1682.44}
                  y1={424.43}
                  y2={472.72}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_102)'
                  d='M1673.3 653.5h-14.2l14.9-44.1h14.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_101'
                  x1={1673.32}
                  x2={1694.29}
                  y1={448.57}
                  y2={448.57}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path
                  fill='url(#svg_101)'
                  d='M1694.3 609.4v44.1h-21l.8-2.4 14.1-41.7z'
                />
                <path
                  className='st6'
                  d='M1670.3 625.4h-1.1c-.7 2.2 0 3.5 1.6 3.6l.4-1c-1-.2-1.3-1-.9-2.6zm4.3 0c-.8 1.6-1.7 2.5-2.8 2.6l-.4 1c1.6-.1 3.4-1.4 4.4-3.6h-1.2zm-5.1-.5h1.1c.8-1.9 1.9-2.8 3.1-2.9l.4-1c-1.9 0-3.7 1.5-4.6 3.9zm5-4.1-.4 1c1.1.1 1.4 1.1.8 2.9h1.1c.9-2.3.1-3.7-1.5-3.9zM1681.8 625.4h-1.6l-.1.2c.5.1.8.4.5 1-.3.9-1.2 1.4-2.4 1.4-1 0-1.7-.3-2.1-.9l-.9.9c.4.7 1.4 1 2.5 1 2.1 0 3.5-1.1 3.9-2.4.3-.5.4-1 .2-1.2zm-3.6-4.1-.4 1h3.8l-2.9 2.5v.1h1.2l.3-.2.2-.1 2.8-2.4.3-.8h-5.3v-.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_100'
                  x1={1674}
                  x2={1688.24}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_100)' d='M1674 599h14.2v10.4H1674z' />
                <path
                  className='st102'
                  d='M1686.8 606.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.2.3-.2.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_99'
                  x1={1675.05}
                  x2={1687.2}
                  y1={475.96}
                  y2={475.96}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1687.2 601.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_99)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1678.9 601.6-1.5 4.7h-1.3l1.6-4.7zM1686.4 601.6l-1.6 4.7h-3.2l1.5-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1687.2 603.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_98'
                  x1={1675.35}
                  x2={1675.35}
                  y1={473.63}
                  y2={478.37}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1675.6 606.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7c-.1 0-.1 0 0 0z'
                  fill='url(#svg_98)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_97'
                  x1={1704.26}
                  x2={1704.26}
                  y1={470.63}
                  y2={479.28}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_97)' d='M1689.6 600.8h29.2v8.6h-29.2z' />
                <path
                  className='st102'
                  d='M1718.7 607.4h-28.4c-.1 0-.3-.1-.3-.3v-5.7c0-.1.1-.3.3-.3h28.4c.1 0 .3.1.3.3v5.7c0 .2-.2.3-.3.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_96'
                  x1={1692.7}
                  x2={1692.7}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1695 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_96)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_95'
                  x1={1697.5}
                  x2={1697.5}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1699.8 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_95)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_94'
                  x1={1702.3}
                  x2={1702.3}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1704.6 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_94)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_93'
                  x1={1707.1}
                  x2={1707.1}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1709.4 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_93)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_92'
                  x1={1711.9}
                  x2={1711.9}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1714.2 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0z'
                  fill='url(#svg_92)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_91'
                  x1={1716.7}
                  x2={1716.7}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1719 601.4v5.9h-4.5c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h4.5z'
                  fill='url(#svg_91)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_90'
                  x1={1690.62}
                  x2={1690.62}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1690.8 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_90)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_89'
                  x1={1700.23}
                  x2={1700.23}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1700.4 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_89)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_88'
                  x1={1704.7}
                  x2={1704.7}
                  y1={472.74}
                  y2={475.33}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='m1690.4 604.7 4.6.7v1.9c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.6zm4.8.6v1.9c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-1.6l-2.6.1-2-.4zm4.8 1.9s0 .1 0 0l4.5.1c.1 0 .1 0 .1-.1v-1.9l-4.6.2v1.7zm4.8 0s0 .1 0 0l4.5.1c.1 0 .1 0 .1-.1v-2.1l-4.6.2v1.9zm4.8-2.1v2.1c0 .1 0 .1.1.1h4.4c.1 0 .1 0 .1-.1v-2.1h-4.6zm4.8 0v2.1c0 .1 0 .1.1.1h4.5v-2.2h-4.6z'
                  enableBackground='new'
                  fill='url(#svg_88)'
                  opacity={0.25}
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1699.5 601.4-2.8 5.9h-1.3l2.8-5.9zM1703.6 607.3l.9-1.9v1.7c0 .1 0 .1-.1.1h-.8v.1zM1709.4 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-2.3l1.6-3.5 3 .1c-.1-.1 0-.1 0 0zM1714.2 601.5v5.7c0 .1 0 .1-.1.1h-4.4c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1l4.5.1c-.1-.1 0-.1 0 0zM1717.4 601.4l-2.7 5.9h-.1c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h2.8z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_87'
                  x1={1709.83}
                  x2={1709.83}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1710 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_87)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_86'
                  x1={1714.63}
                  x2={1714.63}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1714.8 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_86)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_85'
                  x1={1695.42}
                  x2={1695.42}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1695.6 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_85)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_84'
                  x1={1705.03}
                  x2={1705.03}
                  y1={472.74}
                  y2={478.6}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1705.2 607.3h-.3c-.1 0-.1 0-.1-.1v-5.7c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 5.8c-.1-.1 0 0 0 0z'
                  fill='url(#svg_84)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_83'
                  x1={1706.77}
                  x2={1706.77}
                  y1={463.79}
                  y2={470.63}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={0.22} stopColor='#9FB4B9' />
                  <stop offset={0.49} stopColor='#ADC0C3' />
                  <stop offset={0.8} stopColor='#C4D5D6' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='m1719.2 609.4-.3 1h-17.8c-1.5 0-2.8 1.3-2.8 2.8v1.4c-1.4.3-2.7.9-3.9 1.5v-6.9h24.9v.2h-.1z'
                  fill='url(#svg_83)'
                />
                <path
                  className='st80'
                  d='m1718.9 610.4-2.6 7.5h-18v-4.7c0-1.5 1.3-2.8 2.8-2.8h17.8z'
                />
                <path
                  className='st80'
                  d='m1718.6 610.4-.1.4-2.4 7h-13.9v-4.7c0-1.5 1.3-2.8 2.8-2.8h13.5v.1h.1z'
                />
                <path
                  className='st81'
                  d='m1718.3 610.9-2.5 7.5h-10.4v-4.7c0-1.5 1.3-2.8 2.8-2.8h10.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_82'
                  x1={1698.75}
                  x2={1698.75}
                  y1={426.53}
                  y2={465.75}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.58} stopColor='#95C9ED' />
                  <stop offset={0.76} stopColor='#C9E5F8' />
                  <stop offset={0.86} stopColor='#AEDAF5' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='m1717.5 614.3-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  fill='url(#svg_82)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_81'
                  x1={1679.98}
                  x2={1717.47}
                  y1={446.12}
                  y2={446.12}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.2} stopColor='#FAFBFD' />
                  <stop offset={0.34} stopColor='#EFF1F8' />
                  <stop offset={0.46} stopColor='#DFE4F1' />
                  <stop offset={0.57} stopColor='#C9D2E7' />
                  <stop offset={0.67} stopColor='#AEBEDC' />
                  <stop offset={0.77} stopColor='#8FA6D0' />
                  <stop offset={0.87} stopColor='#6B8FC2' />
                  <stop offset={0.96} stopColor='#3D78B4' />
                  <stop offset={1} stopColor='#166EAE' />
                </linearGradient>
                <path
                  d='m1717.5 614.3-13.4 39.2h-24c0-8.8 5.2-20.8 7.9-29.2 1.1-3.5 3.4-6.3 6.4-8.1 1.2-.8 2.5-1.2 3.9-1.5 1.1-.2 2.2-.3 3.3-.3l15.9-.1z'
                  enableBackground='new'
                  fill='url(#svg_81)'
                  opacity={0.4}
                />
                <g className='st84'>
                  <path
                    className='st85'
                    d='M1682.1 650.3c.3-2.8.9-5.6 1.4-8.3h.1v.1c-.5 2.6-1.1 5.4-1.5 8.2.1 0 .1 0 0 0zM1702.5 650.3c-.1 0-.1 0 0 0 .3-2.8.9-5.6 1.4-8.3h.1v.1c-.6 2.6-1 5.4-1.5 8.2zM1684.9 636.6c-.1 0-.1 0 0 0 .7-2.8 1.5-5.6 2.5-8.7h.1v.1c-.9 3-1.8 5.8-2.6 8.6zM1705.7 636.6c.7-2.8 1.5-5.6 2.5-8.7h.1v.1c-1 3-1.9 5.8-2.6 8.6.1 0 0 0 0 0zM1689 623.8s-.1 0 0 0c-.1-.1-.1-.1 0 0l.2-.8c.8-2.3 2.3-4.1 4.5-5.6 1-.7 2.2-1.1 3.4-1.4 1.2-.3 2.4-.5 3.7-.5 0 0 .1 0 .1.1 0 0 0 .1-.1.1-5.3 0-9.9 2.9-11.5 7.4l-.3.7c0-.1 0 0 0 0zM1709.1 623.8c0-.1 0-.1 0 0l.2-.8c1-2.8 3.2-5 6.1-6.3h.1v.1c-2.9 1.3-5.1 3.5-6.1 6.3l-.3.7c.1-.1 0 0 0 0zM1692.5 650.3c0-.1.4-2.5 1.1-5.9h.1v.1c-.7 3.3-1.1 5.7-1.2 5.8.1 0 0 0 0 0zM1695.1 637c-.1 0-.1 0 0 0 1.1-5.8 2-9.9 2.5-12.5h.1v.1c-.6 2.5-1.5 6.7-2.6 12.4zM1701 618.4c0-.1 0-.1 0 0 1.4-1.2 2.9-1.7 4-2.1 1.2-.3 2-.4 2-.4h.1v.1s-.9.1-2 .4c-1.1.3-2.7 1-4.1 2 .1 0 .1 0 0 0z'
                  />
                  <path
                    className='st78'
                    d='M1696.5 651.7c-.1 0-.1 0 0 0 .1-1.3 1-5.1 2.5-11.6h.1v.1c-1.5 6.4-2.4 10.3-2.6 11.5zM1700.8 632.7s0-.1 0 0c.3-1.6.7-3.3 1.1-5h.1v.1c-.4 1.7-.8 3.3-1.2 4.9.1 0 .1 0 0 0zM1703.2 623c-.1 0-.1 0 0 0 .4-1.5 1.1-2.8 2-3.8.8-.9 1.5-1.5 2.5-2.1 1.6-.9 2.9-1 3.1-1h.1v.1s-1.4.1-2.9 1c-1.8.8-3.7 2.6-4.8 5.8zM1687.5 651.7c0-.7.3-1.9.5-3.5h.1v.1c-.2 1.6-.4 2.8-.6 3.4.1 0 .1 0 0 0zM1689.3 642.7c-.1 0-.1 0 0 0 .3-1.7.7-3.4 1-5h.1v.1c-.3 1.5-.8 3.2-1.1 4.9z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_80'
                  x1={1691.66}
                  x2={1691.66}
                  y1={426.51}
                  y2={435.07}>
                  <stop offset={0} stopColor='#B8DDF5' />
                  <stop offset={0.6} stopColor='#D8EDFA' />
                  <stop offset={1} stopColor='#E7F6FD' />
                </linearGradient>
                <path
                  d='m1704.8 651.1-.8 2.4h-24.7c-.5-.5-.9-1.3-.9-2.3v-.1c.1-1.5 1.1-2.7 2.4-2.7.4 0 .9.1 1.2.3.1-.1.1-.3.2-.4.5-.8 1.3-1.5 2.4-2 1.6-.8 3.4-.8 4.4 0 .3-.5.9-1.1 1.5-1.2 1.1-.3 2.3.2 3.1 1.2.1-.2.3-.4.5-.5v5.3h10.7z'
                  fill='url(#svg_80)'
                />
                <path
                  className='st87'
                  d='M1681.3 653.5h-.5c-.1-.3-.2-.7-.2-1 0-.4 0-1 .2-1.4.1-.3.3-.5.5-.8-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1s.1.7.3 1c0 .2 0 .3.1.4zM1698.2 647.4c-.3-.1-.5-.1-.9-.1-1 0-2 .3-2.7 1 0-.1 0-.2-.1-.3.7-.4 1.5-.8 2.4-.8.4-.1.8.1 1.3.2zM1701.4 649.8l-.2.2c-.2-.4-.4-.9-.8-1.3-.2-.2-.5-.5-.9-.7-.1-.1-.2-.1-.3-.2.2.1.4.2.7.3.3.2.5.4.9.7.3.3.5.6.6 1zM1700.4 651.1c-.2.4-.3.9-.3 1.4 0 .2 0 .5.1.8 0 .1 0 .1.1.2h-6.2c.2-.3.3-.7.3-1 0-.5-.3-1.1-.8-1.4.1 0 .1.1.2.1.5.3.9.9.9 1.5 0 .3.2.5.5.5h4.6v-.3c.1-.6.2-1.3.6-1.8 0-.1.1-.2.1-.2-.1.1-.1.2-.1.2zM1691.8 651.7v.2c0 .5-.2 1.1-.4 1.5h-6c-.2-.4-.3-1-.3-1.6 0-.3 0-.5.1-.8.1-.3.2-.7.3-1 .1-.1.1-.2.2-.3.1-.1.1-.2.2-.3-.1.1-.1.2-.2.3-.2.4-.3.9-.4 1.3v.5c0 .8.7 1.4 1.5 1.4h4.3c.2-.4.3-.9.3-1.4v-.8c-.1-.9-.7-1.5-1.2-2.1-.1-.1-.2-.1-.2-.2-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1c.2 0 .3.1.5.2.1-.4 0-1-.1-1.3-.2-.3-.4-.7-.8-.9.4.2.9.5 1.1 1.1.2.4.2.9.1 1.4.8.4 1.3 1.2 1.5 2.1v.9zM1683.2 649.8c-.4-.9-1.2-1.1-1.2-1.1.1-.1.1-.3.2-.4.6.3 1 .9 1 1.5z'
                />
                <defs>
                  <path id='svg_79' d='M618.2 238.5h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_77' d='M616 236.3h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_78'>
                  <use overflow='visible' xlinkHref='#svg_79' />
                </clipPath>
                <clipPath id='svg_68'>
                  <use overflow='visible' xlinkHref='#svg_77' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={13.7}
                    id='svg_71'
                    width={35.1}
                    x={1675.9}
                    y={639.7}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={13.7}
                  id='svg_70'
                  maskUnits='userSpaceOnUse'
                  width={35.1}
                  x={1675.9}
                  y={639.7}>
                  <g filter='url(#svg_71)'>
                    <defs>
                      <path id='svg_76' d='M618.2 238.5h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_74' d='M616 236.3h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_75'>
                      <use overflow='visible' xlinkHref='#svg_76' />
                    </clipPath>
                    <clipPath id='svg_72'>
                      <use overflow='visible' xlinkHref='#svg_74' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_73'
                      x1={1693.46}
                      x2={1693.46}
                      y1={426.51}
                      y2={439.84}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={1} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_72)'
                      d='M1711 650.3c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.9.5 3.5 2.1 3.5 4.1z'
                      fill='url(#svg_73)'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_69'
                  x1={1693.46}
                  x2={1693.46}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} />
                </linearGradient>
                <path
                  clipPath='url(#svg_68)'
                  d='M1711 650.3c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.9.5 3.5 2.1 3.5 4.1z'
                  fill='url(#svg_69)'
                  mask='url(#svg_70)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_67'
                  x1={1693.46}
                  x2={1693.46}
                  y1={426.51}
                  y2={439.84}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={1} stopColor='#9CD0F1' />
                </linearGradient>
                <path
                  d='M1711 650.3c0 1.3-.8 2.5-1.9 3.2h-1.2v-.3c0-1.4-1.2-3.1-2.6-3.8 0 0-.1 0-.1-.1-.5-.2-1.1-.4-1.5-.4-.3 0-.7 0-1 .1.1-.2.1-.4.1-.7 0-1-.8-1.9-1.9-1.9-.8 0-1.4.5-1.7 1.2-.3-.2-.8-.3-1.2-.4-.3-1-1.3-1.9-2.4-1.9-.5 0-1 .1-1.4.2v5.3h10.6l-.8 2.4h-26.3c-.9-.5-1.5-1.3-1.7-2.4 0-.2-.1-.5-.1-.8 0-1.6 1.1-2.9 2.5-3.5v-.7c0-2.9 2.4-5.3 5.3-5.3 1 0 2 .3 2.8.8.8-1 2-1.6 3.4-1.6 1.6 0 2.9.9 3.7 2.2.2-.1.4-.1.8-.2h.7c1.5 0 2.8.7 3.7 1.7.8-.7 1.7-1 2.8-1 2.4 0 4.4 1.7 4.7 4h.1c.3-.1.8-.2 1.1-.2 1.9.5 3.5 2.1 3.5 4.1z'
                  enableBackground='new'
                  fill='url(#svg_67)'
                  opacity={0.5}
                />
                <g className='st95'>
                  <path
                    className='st6'
                    d='M1682.3 645.4c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0-.1.2 0 .2.2z'
                  />
                  <circle className='st6' cx={1678.6} cy={651.3} r={0.2} />
                  <path
                    className='st6'
                    d='M1689.3 642.2c0 .1-.1.1-.1.1l-.1-.1.1-.1.1.1zM1685.5 642.9c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zM1696.3 644.6c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0 0 0 0zM1699.1 645.8c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1693.9 642.9s0 .1 0 0c-.1.1-.2 0-.2 0 .1-.1.1-.1.2 0 0-.1 0-.1 0 0zM1687.2 644.3c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1676.8 649.8c-.1.1-.1 0-.1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0zM1681.9 643.2c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1681.2 647.6c0 .1-.1.1 0 0-.1.1-.1 0-.1 0h.1c-.1 0 0 0 0 0z'
                  />
                  <circle className='st6' cx={1699.8} cy={644} r={0.1} />
                  <circle className='st6' cx={1703.9} cy={644.6} r={0.1} />
                  <path
                    className='st6'
                    d='M1702.4 643.6s-.1 0 0 0c-.1 0-.1 0 0 0-.1 0-.1-.1 0 0-.1-.1 0 0 0 0zM1704.4 647.5s0 .1 0 0c-.1.1-.1 0 0 0-.1 0-.1 0 0 0zM1707.2 647.4c-.1.1-.1 0-.1 0s0-.1.1 0c0-.1 0-.1 0 0zM1707.4 650.1c-.1.1-.1 0-.1 0 0-.1 0-.1.1 0 0-.1 0-.1 0 0zM1709.3 652.1c0 .1 0 .1 0 0-.1.1-.1 0-.1 0h.1zM1708.6 652.9c0 .1 0 .1 0 0-.1.1-.1.1 0 0-.1 0-.1 0 0 0z'
                  />
                </g>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_66'
                  x1={1718.95}
                  x2={1733.19}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path fill='url(#svg_66)' d='M1719 599h14.2v10.4H1719z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_65'
                  x1={1718.61}
                  x2={1718.61}
                  y1={426.53}
                  y2={470.61}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  fill='url(#svg_65)'
                  d='M1733.2 609.4v44.1H1704l.8-2.4.6-1.7.8-2.5 12.8-37.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_64'
                  x1={1733.18}
                  x2={1746.52}
                  y1={448.57}
                  y2={448.57}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_64)' d='M1733.2 609.4h13.3v44.1h-13.3z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_63'
                  x1={1733.18}
                  x2={1746.52}
                  y1={475.8}
                  y2={475.8}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#B6C5C7' />
                </linearGradient>
                <path fill='url(#svg_63)' d='M1733.2 599h13.3v10.4h-13.3z' />
                <path
                  className='st102'
                  d='M1731.8 606.5h-11.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h11.5c.3 0 .5.2.5.5v4c.1.3-.2.5-.5.5z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_62'
                  x1={1719.99}
                  x2={1732.14}
                  y1={475.96}
                  y2={475.96}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1732.1 601.7v4.6s0 .1-.1.1h-12s-.1 0-.1-.1v-4.6s0-.1.1-.1l12.1.1c0-.1 0-.1 0 0z'
                  fill='url(#svg_62)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1723.9 601.6-1.5 4.7h-1.3l1.5-4.7zM1731.3 601.6l-1.5 4.7h-3.3l1.6-4.7z'
                  />
                </g>
                <path
                  className='st131'
                  d='M1732.1 603.9v2.4s0 .1-.1.1h-12s-.1 0-.1-.1v-1.5h7.4l4.8-.9z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_61'
                  x1={1720.2}
                  x2={1720.2}
                  y1={473.63}
                  y2={478.37}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1720.4 606.3h-.3c-.1 0-.1 0-.1-.1v-4.6c0-.1 0-.1.1-.1h.3c-.1 0-.1 0-.1.1l.1 4.7z'
                  fill='url(#svg_61)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_60'
                  x1={1736.18}
                  x2={1736.18}
                  y1={426.53}
                  y2={460.41}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.05} stopColor='#708EB0' />
                  <stop offset={0.13} stopColor='#819EBC' />
                  <stop offset={0.23} stopColor='#8EACC6' />
                  <stop offset={0.35} stopColor='#98B6CE' />
                  <stop offset={0.52} stopColor='#9EBCD2' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path fill='url(#svg_60)' d='M1730.1 619.6h12.1v33.8h-12.1z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_59'
                  x1={1746.55}
                  x2={1746.55}
                  y1={426.53}
                  y2={459.59}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.04} stopColor='#57789F' />
                  <stop offset={0.12} stopColor='#6987A8' />
                  <stop offset={0.22} stopColor='#7694B1' />
                  <stop offset={0.34} stopColor='#809EB8' />
                  <stop offset={0.51} stopColor='#86A4BB' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_59)' d='M1742.2 620.4h8.6v33.1h-8.6z' />
                <path
                  className='st102'
                  d='M1740.6 650.2h-8.9c-.5 0-.9-.4-.9-.9v-25.1c0-.5.4-.9.9-.9h8.9c.5 0 .9.4.9.9v25.1c.1.5-.4.9-.9.9z'
                />
                <path
                  className='st184'
                  d='M1731.7 650h-.4c-.1 0-.2-.1-.2-.2v-25.9c0-.1.1-.2.2-.2h.4c-.1 0-.2.1-.2.2v25.9c-.2 0 0 .2.2.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_58'
                  x1={1727.39}
                  x2={1745.43}
                  y1={434.21}
                  y2={452.25}>
                  <stop offset={0} stopColor='#6383A8' />
                  <stop offset={0.13} stopColor='#7593B4' />
                  <stop offset={0.31} stopColor='#87A5C1' />
                  <stop offset={0.5} stopColor='#95B2CB' />
                  <stop offset={0.71} stopColor='#9DBBD1' />
                  <stop offset={0.99} stopColor='#A0BED4' />
                </linearGradient>
                <path
                  d='M1741.4 623.8v25.9c0 .1-.1.2-.2.2h-9.4c-.1 0-.2-.1-.2-.2v-25.9c0-.1.1-.2.2-.2h9.4c-.1-.1.2 0 .2.2z'
                  fill='url(#svg_58)'
                />
                <path
                  className='st102'
                  d='M1731 625.2h10.4v.3H1731zM1731 629.8h10.4v.3H1731zM1731 634.3h10.4v.3H1731zM1731 638.8h10.4v.3H1731zM1731 643.3h10.4v.3H1731zM1731 647.9h10.4v.3H1731z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_57'
                  x1={1744.91}
                  x2={1744.91}
                  y1={459.59}
                  y2={460.39}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='M1751.1 620.4h-12.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h12.3c.2 0 .4.2.4.4s-.2.4-.4.4z'
                  fill='url(#svg_57)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_56'
                  x1={1736.07}
                  x2={1736.07}
                  y1={459.59}
                  y2={460.39}>
                  <stop offset={0} stopColor='#9BB0B5' />
                  <stop offset={1} stopColor='#D7E7E6' />
                </linearGradient>
                <path
                  d='M1742.2 620.4h-12.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h12.3c.2 0 .4.2.4.4.1.2-.1.4-.4.4z'
                  fill='url(#svg_56)'
                />
                <g className='st95'>
                  <path
                    className='st102'
                    d='m1735 623.5-3.7 11.5v-3.4l2.6-8.1zM1741.4 623.8v11.8l-4.5 14.4h-4.6l8.3-26.4h.4c.1-.1.4 0 .4.2z'
                  />
                </g>
                <defs>
                  <path id='svg_55' d='M618.2 238.5h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_53' d='M616 236.3h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_54'>
                  <use overflow='visible' xlinkHref='#svg_55' />
                </clipPath>
                <clipPath id='svg_44'>
                  <use overflow='visible' xlinkHref='#svg_53' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={0.8}
                    id='svg_47'
                    width={12.1}
                    x={1730.1}
                    y={620.4}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={0.8}
                  id='svg_46'
                  maskUnits='userSpaceOnUse'
                  width={12.1}
                  x={1730.1}
                  y={620.4}>
                  <g filter='url(#svg_47)'>
                    <defs>
                      <path id='svg_52' d='M618.2 238.5h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_50' d='M616 236.3h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_51'>
                      <use overflow='visible' xlinkHref='#svg_52' />
                    </clipPath>
                    <clipPath id='svg_48'>
                      <use overflow='visible' xlinkHref='#svg_50' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_49'
                      x1={1736.18}
                      x2={1736.18}
                      y1={459.59}
                      y2={458.87}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={0.12} stopColor='#C6C6C6' />
                      <stop offset={0.24} stopColor='#929292' />
                      <stop offset={0.37} stopColor='#656565' />
                      <stop offset={0.49} stopColor='#414141' />
                      <stop offset={0.62} stopColor='#242424' />
                      <stop offset={0.74} stopColor='#101010' />
                      <stop offset={0.87} stopColor='#040404' />
                      <stop offset={0.99} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_48)'
                      fill='url(#svg_49)'
                      d='M1730.1 620.4h12.1v.8h-12.1z'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_45'
                  x1={1736.18}
                  x2={1736.18}
                  y1={459.59}
                  y2={458.87}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.12} stopColor='#C6C6C6' />
                  <stop offset={0.24} stopColor='#929292' />
                  <stop offset={0.37} stopColor='#656565' />
                  <stop offset={0.49} stopColor='#414141' />
                  <stop offset={0.62} stopColor='#242424' />
                  <stop offset={0.74} stopColor='#101010' />
                  <stop offset={0.87} stopColor='#040404' />
                  <stop offset={0.99} />
                </linearGradient>
                <path
                  clipPath='url(#svg_44)'
                  fill='url(#svg_45)'
                  mask='url(#svg_46)'
                  d='M1730.1 620.4h12.1v.8h-12.1z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_43'
                  x1={1736.18}
                  x2={1736.18}
                  y1={459.59}
                  y2={458.87}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.05} stopColor='#53749C' />
                  <stop offset={0.29} stopColor='#6A88A9' />
                  <stop offset={0.52} stopColor='#7A98B3' />
                  <stop offset={0.76} stopColor='#84A2BA' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_43)' d='M1730.1 620.4h12.1v.8h-12.1z' />
                <defs>
                  <path id='svg_42' d='M618.2 238.5h1.1l-1.1 1.1z' />
                </defs>
                <defs>
                  <path id='svg_40' d='M616 236.3h-1.1l1.1-1.1z' />
                </defs>
                <clipPath id='svg_41'>
                  <use overflow='visible' xlinkHref='#svg_42' />
                </clipPath>
                <clipPath id='svg_31'>
                  <use overflow='visible' xlinkHref='#svg_40' />
                </clipPath>
                <defs>
                  <filter
                    filterUnits='userSpaceOnUse'
                    height={0.8}
                    id='svg_34'
                    width={8.6}
                    x={1742.2}
                    y={620.4}>
                    <feColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0' />
                  </filter>
                </defs>
                <mask
                  height={0.8}
                  id='svg_33'
                  maskUnits='userSpaceOnUse'
                  width={8.6}
                  x={1742.2}
                  y={620.4}>
                  <g filter='url(#svg_34)'>
                    <defs>
                      <path id='svg_39' d='M618.2 238.5h1.1l-1.1 1.1z' />
                    </defs>
                    <defs>
                      <path id='svg_37' d='M616 236.3h-1.1l1.1-1.1z' />
                    </defs>
                    <clipPath id='svg_38'>
                      <use overflow='visible' xlinkHref='#svg_39' />
                    </clipPath>
                    <clipPath id='svg_35'>
                      <use overflow='visible' xlinkHref='#svg_37' />
                    </clipPath>
                    <linearGradient
                      gradientTransform='matrix(1 0 0 -1 0 1080)'
                      gradientUnits='userSpaceOnUse'
                      id='svg_36'
                      x1={1746.55}
                      x2={1746.55}
                      y1={459.59}
                      y2={458.87}>
                      <stop offset={0} stopColor='#FFF' />
                      <stop offset={0.12} stopColor='#C6C6C6' />
                      <stop offset={0.24} stopColor='#929292' />
                      <stop offset={0.37} stopColor='#656565' />
                      <stop offset={0.49} stopColor='#414141' />
                      <stop offset={0.62} stopColor='#242424' />
                      <stop offset={0.74} stopColor='#101010' />
                      <stop offset={0.87} stopColor='#040404' />
                      <stop offset={0.99} />
                    </linearGradient>
                    <path
                      clipPath='url(#svg_35)'
                      fill='url(#svg_36)'
                      d='M1742.2 620.4h8.6v.8h-8.6z'
                    />
                  </g>
                </mask>
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_32'
                  x1={1746.55}
                  x2={1746.55}
                  y1={459.59}
                  y2={458.87}>
                  <stop offset={0} stopColor='#FFF' />
                  <stop offset={0.12} stopColor='#C6C6C6' />
                  <stop offset={0.24} stopColor='#929292' />
                  <stop offset={0.37} stopColor='#656565' />
                  <stop offset={0.49} stopColor='#414141' />
                  <stop offset={0.62} stopColor='#242424' />
                  <stop offset={0.74} stopColor='#101010' />
                  <stop offset={0.87} stopColor='#040404' />
                  <stop offset={0.99} />
                </linearGradient>
                <path
                  clipPath='url(#svg_31)'
                  fill='url(#svg_32)'
                  mask='url(#svg_33)'
                  d='M1742.2 620.4h8.6v.8h-8.6z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_30'
                  x1={1746.55}
                  x2={1746.55}
                  y1={459.59}
                  y2={458.87}>
                  <stop offset={0} stopColor='#4C7099' />
                  <stop offset={0.05} stopColor='#53749C' />
                  <stop offset={0.29} stopColor='#6A88A9' />
                  <stop offset={0.52} stopColor='#7A98B3' />
                  <stop offset={0.76} stopColor='#84A2BA' />
                  <stop offset={0.99} stopColor='#88A6BD' />
                </linearGradient>
                <path fill='url(#svg_30)' d='M1742.2 620.4h8.6v.8h-8.6z' />
                <path
                  className='st202'
                  d='M1731.8 617v.3c0 .4-.3.8-.8.8h-2c-1.2 0-2.1 1-2.1 2.1v33.4h-1.5V620c0-1.5 1.2-2.7 2.7-2.7h3.3c.1-.2.3-.2.4-.3zM1724.6 617.1c0 .1-.1.1-.1.1-.5.8-.9 1.6-.9 2.6V653.5h-1.5V620c.1-1.6 1-2.6 2.5-2.9zM1721.3 617.1c0 .1-.1.1-.1.1-.5.8-.9 1.6-.9 2.6V653.5h-1.5V620c.1-1.6 1.1-2.6 2.5-2.9z'
                />
                <path
                  className='st203'
                  d='M1725.3 616.3c0 .5-.3.9-.7.9h-2.9c-1.5 0-2.7 1.2-2.7 2.7v33.6h-1.9v-33.6c0-2.5 2.1-4.6 4.6-4.6h2.9c.4 0 .7.4.7 1z'
                />
                <path
                  className='st203'
                  d='M1728.6 616.3c0 .5-.3.9-.7.9h-2.9c-1.5 0-2.7 1.2-2.7 2.7v33.6h-1.9v-33.6c0-2.5 2.1-4.6 4.6-4.6h2.9c.4 0 .7.4.7 1z'
                />
                <path
                  className='st204'
                  d='M1724.9 616.7c-.1.1-.2.3-.3.4-1.3.2-2.4 1.3-2.4 2.7v33.6h-.5v-33.7c0-1.7 1.4-3.1 3.1-3.1h.1v.1zM1721.6 616.7c-.1.1-.2.3-.3.4-1.3.2-2.4 1.3-2.4 2.7v33.6h-.5v-33.7c0-1.7 1.4-3.1 3.1-3.1h.1v.1z'
                />
                <path
                  className='st203'
                  d='M1725.1 616.3c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V619.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1720.2c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.4-.2.4-.1.4.3 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_29'
                  x1={1724.46}
                  x2={1725.44}
                  y1={463.61}
                  y2={463.61}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 616.3c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.7-.5 1-.1 1 .5z'
                  fill='url(#svg_29)'
                />
                <path
                  className='st204'
                  d='M1725 616.7c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_28'
                  x1={1717.85}
                  x2={1717.85}
                  y1={456.51}
                  y2={456.82}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 623.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1-.1.1-.1.1z'
                  fill='url(#svg_28)'
                />
                <path className='st204' d='M1716.9 623.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_27'
                  x1={1717.85}
                  x2={1717.85}
                  y1={450.96}
                  y2={451.26}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 629h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1-.1.1-.1.1z'
                  fill='url(#svg_27)'
                />
                <path className='st204' d='M1716.9 629h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_26'
                  x1={1717.85}
                  x2={1717.85}
                  y1={445.4}
                  y2={445.7}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 634.6h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_26)'
                />
                <path className='st204' d='M1716.9 634.6h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_25'
                  x1={1717.85}
                  x2={1717.85}
                  y1={439.85}
                  y2={440.15}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 640.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0-.1-.1.1-.1.1z'
                  fill='url(#svg_25)'
                />
                <path className='st204' d='M1716.9 640.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_24'
                  x1={1717.85}
                  x2={1717.85}
                  y1={434.29}
                  y2={434.59}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 645.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_24)'
                />
                <path className='st204' d='M1716.9 645.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_23'
                  x1={1717.85}
                  x2={1717.85}
                  y1={428.74}
                  y2={429.04}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1718.8 651.3h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1l-.1.1z'
                  fill='url(#svg_23)'
                />
                <path className='st204' d='M1716.9 651.3h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_22'
                  x1={3221.48}
                  x2={3221.48}
                  y1={18.83}
                  y2={19.13}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1718.8 619.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2s-.1.1-.2.1z'
                  fill='url(#svg_22)'
                />
                <path
                  className='st204'
                  d='M1718.8 619.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1720.7 617.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.3.1.4.7.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_21'
                  x1={1720.21}
                  x2={1721.05}
                  y1={463.67}
                  y2={463.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1720.9 617.4c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1-.1-.2.1-.2.1z'
                  fill='url(#svg_21)'
                />
                <path
                  className='st203'
                  d='M1728.5 616.3c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V619.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1723.6c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.3-.2.4-.1.4.3 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_20'
                  x1={1727.81}
                  x2={1728.79}
                  y1={463.61}
                  y2={463.61}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1728.8 616.3c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.7-.5 1-.1 1 .5z'
                  fill='url(#svg_20)'
                />
                <path
                  className='st204'
                  d='M1728.4 616.7c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_19'
                  x1={1721.15}
                  x2={1721.15}
                  y1={456.51}
                  y2={456.82}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 623.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1.1 0 .1-.1.1z'
                  fill='url(#svg_19)'
                />
                <path className='st204' d='M1720.3 623.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_18'
                  x1={1721.15}
                  x2={1721.15}
                  y1={450.96}
                  y2={451.26}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 629h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1.1 0 .1-.1.1z'
                  fill='url(#svg_18)'
                />
                <path className='st204' d='M1720.3 629h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_17'
                  x1={1721.15}
                  x2={1721.15}
                  y1={445.4}
                  y2={445.7}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 634.6h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_17)'
                />
                <path className='st204' d='M1720.3 634.6h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_16'
                  x1={1721.15}
                  x2={1721.15}
                  y1={439.85}
                  y2={440.15}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 640.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1-.1 0 .1-.1.1z'
                  fill='url(#svg_16)'
                />
                <path className='st204' d='M1720.3 640.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_15'
                  x1={1721.15}
                  x2={1721.15}
                  y1={434.29}
                  y2={434.59}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 645.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_15)'
                />
                <path className='st204' d='M1720.3 645.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_14'
                  x1={1721.15}
                  x2={1721.15}
                  y1={428.74}
                  y2={429.04}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1722.1 651.3h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1.1 0 0 .1-.1.1z'
                  fill='url(#svg_14)'
                />
                <path className='st204' d='M1720.3 651.3h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_13'
                  x1={3224.77}
                  x2={3224.77}
                  y1={19.62}
                  y2={19.92}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1722.2 619.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2-.1.1-.1.1-.2.1z'
                  fill='url(#svg_13)'
                />
                <path
                  className='st204'
                  d='M1722.2 619.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1724.1 617.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.2.1.3.7.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_12'
                  x1={1723.56}
                  x2={1724.4}
                  y1={463.67}
                  y2={463.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1724.1 617.4c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1-.1-.1.1-.2.1z'
                  fill='url(#svg_12)'
                />
                <path
                  className='st203'
                  d='M1731.9 616.3c0 .2 0 .3-.1.5s-.3.4-.5.4h-2.9c-.2 0-.4 0-.7.1-.1 0-.1 0-.2.1-.4.1-.9.4-1.2.8-.3.3-.5.9-.7 1.3v34.1h-1.9V619.1c.1-.7.4-1.2.8-1.7 0 0 0-.1.1-.1 0-.1.1-.1.1-.2.1-.1.1-.2.2-.2.4-.4 1-.9 1.6-1.1.1 0 .1-.1.2-.1H1727c.3-.1.7-.1 1.1-.1h2.9c.2 0 .3.1.5.3v.1c.3-.2.3-.1.4.3 0-.1 0-.1 0 0z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_11'
                  x1={1731.15}
                  x2={1732.13}
                  y1={463.61}
                  y2={463.61}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1732.1 616.3c0 .3-.2.7-.4.9-.1 0-.2.1-.2.1h-.3.1l.1-.1c.1-.1.1-.3.1-.5 0-.5-.3-.9-.7-.9h.3c.8-.5 1-.1 1 .5z'
                  fill='url(#svg_11)'
                />
                <path
                  className='st204'
                  d='M1731.8 616.7c-.1.2-.3.4-.5.4h-2.9c-1.4 0-2.5 1-2.7 2.3v34h-.5v-34.2c.2-1.4 1.5-2.6 3.1-2.6h3.7v.1h-.2z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_10'
                  x1={1724.51}
                  x2={1724.51}
                  y1={456.51}
                  y2={456.82}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 623.5h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z'
                  fill='url(#svg_10)'
                />
                <path className='st204' d='M1723.6 623.5h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_9'
                  x1={1724.51}
                  x2={1724.51}
                  y1={450.96}
                  y2={451.26}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 629h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0 .1 0 .1-.1.1z'
                  fill='url(#svg_9)'
                />
                <path className='st204' d='M1723.6 629h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_8'
                  x1={1724.51}
                  x2={1724.51}
                  y1={445.4}
                  y2={445.7}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 634.6h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_8)'
                />
                <path className='st204' d='M1723.6 634.6h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_7'
                  x1={1724.51}
                  x2={1724.51}
                  y1={439.85}
                  y2={440.15}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 640.2h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1 0-.1 0 .1-.1.1z'
                  fill='url(#svg_7)'
                />
                <path className='st204' d='M1723.6 640.2h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_6'
                  x1={1724.51}
                  x2={1724.51}
                  y1={434.29}
                  y2={434.59}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 645.7h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_6)'
                />
                <path className='st204' d='M1723.6 645.7h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_5'
                  x1={1724.51}
                  x2={1724.51}
                  y1={428.74}
                  y2={429.04}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1725.4 651.3h-1.9c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1h1.9c.1 0 .1.1.1.1s0 .1-.1.1z'
                  fill='url(#svg_5)'
                />
                <path className='st204' d='M1723.6 651.3h1.9v.2h-1.9z' />
                <linearGradient
                  gradientTransform='scale(1 -1) rotate(-13.644 -196.88 5983.924)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_4'
                  x1={3228.06}
                  x2={3228.06}
                  y1={20.41}
                  y2={20.71}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='m1725.5 619.4-1.7-.4c-.1 0-.1-.1-.1-.2s.1-.1.2-.1l1.7.4c.1 0 .1.1.1.2s-.2.1-.2.1z'
                  fill='url(#svg_4)'
                />
                <path
                  className='st204'
                  d='M1725.4 619.4v.2l-.5-.1-1.3-.3v-.2l1.3.3.5.1zM1727.5 617.2c-.1 0-.1 0-.2.1v-.1c.3-1.1-.4-1.6-.4-1.6h.2l.3.3c.1.1.3.7.1 1.3z'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_3'
                  x1={1726.9}
                  x2={1727.74}
                  y1={463.67}
                  y2={463.67}>
                  <stop offset={0} stopColor='#F57E20' />
                  <stop offset={0.29} stopColor='#F8993C' />
                  <stop offset={0.58} stopColor='#FBB259' />
                  <stop offset={0.83} stopColor='#FDC16B' />
                  <stop offset={1} stopColor='#FEC771' />
                </linearGradient>
                <path
                  d='M1727.5 617.4c-.1 0-.1-.1-.1-.1.3-1.1-.4-1.6-.4-1.6-.1 0-.1-.1 0-.2 0-.1.1-.1.2 0 0 0 .2.1.4.4.2.3.3.8.1 1.4-.1-.1-.1.1-.2.1z'
                  fill='url(#svg_3)'
                />
                <linearGradient
                  gradientTransform='matrix(1 0 0 -1 0 1080)'
                  gradientUnits='userSpaceOnUse'
                  id='svg_2'
                  x1={1632.68}
                  x2={1632.68}
                  y1={426.51}
                  y2={428.89}>
                  <stop offset={0} stopColor='#79AACE' />
                  <stop offset={0.61} stopColor='#6BA4CE' />
                  <stop offset={1} stopColor='#DCEFFB' />
                </linearGradient>
                <path
                  d='m1704.8 651.1-.8 2.4h-142.5c-.5 0-1-.4-1-1 0-.8.7-1.3 1.3-1.3h143v-.1z'
                  fill='url(#svg_2)'
                />
                <path
                  style={{
                    fill: "none",
                    stroke: "#4457a6",
                    strokeWidth: 18,
                    strokeMiterlimit: 10,
                  }}
                  d='m1214.3 622.1-109-44.4-37.2-77.7'
                />
                <path
                  className='st4'
                  d='m1551.1 166.5-2 26.2-266 173.2-11.5-17.5z'
                />
                <text
                  className='st27'
                  style={{
                    fontSize: "23px",
                  }}
                  transform='matrix(1.051 0 0 1 1052.384 280.273)'>
                  <tspan x={0} y={0}>
                    {"Uchqo\u2019rg\u2019on GU"}
                  </tspan>
                </text>
                <text
                  className='st9 st10'
                  style={{
                    fontSize: "20px",
                  }}
                  transform='matrix(1.051 0 0 1 1152.384 306.273)'>
                  <tspan x={0} y={0}>
                    {`${data[347] ? data[347]["suvi"] : "0"} m\u00B3/s`}
                  </tspan>
                </text>
                <text
                  style={{
                    fontSize: "23px",
                  }}
                  className='st27'
                  transform='translate(1360.876 520.348)'>
                  {"Teshiktosh G/U"}
                </text>
                <text
                  style={{
                    fontSize: "20px",
                  }}
                  className='st9'
                  transform='translate(1384.876 545.348)'>
                  {`${data[483] ? data[483]["suvi"] : "0"} m\u00B3/s`}
                </text>
                <text
                  transform='translate(431.745 347.525)'
                  style={{
                    fontSize: "23px",
                    fontFamily: "'Poppins-MediumItalic'",
                  }}>
                  {"Sirdaryo"}
                </text>
                <path
                  className='st4'
                  d='M1547.4 791.9v34c0 13.1-3.6 23.6-7.9 23.6v-57.7h7.9v.1zM338.7 631.2h195v9.9h-195zM543.6 609.5v18.7c0 7.2-4.4 13-9.9 13v-31.6h9.9v-.1zM787.1 741.9h95.1v9.9h-95.1zM892.1 766.1v-14.3c0-5.5-4.4-9.9-9.9-9.9v24.2h9.9z'
                />
                <text
                  className='st50'
                  transform='matrix(.8065 .3191 -.368 .9298 1124.601 568.817)'
                  style={{
                    fontSize: "20px",
                  }}>
                  {"Qoradaryo"}
                </text>
                <path
                  className='st532'
                  d='m1230.4 617 197.9-261-39.3-82.4M1232.5 150.2 1353.3 296'
                />
                <path
                  className='st533'
                  d='m913.9 581 148.2-95M843.1 431l61.2-59.5'
                />
                <path
                  className='st4'
                  d='m1167.2 714.1 53.1-83.7M1169.9 718.6l-5.5-9.1 53.3-82.8 8.9 5.7z'
                />
                <path
                  className='st532'
                  d='m1534.3 787.1-250.5-32.5-88.3-82.4'
                />
                <text
                  className='st7'
                  transform='translate(1334.072 115.355)'
                  style={{
                    fontSize: "23px",
                  }}>
                  {"KNK"}
                </text>
                <path d='M1415.9 594.3h29v55.3h-29z' />
                <path
                  transform='rotate(-57.825 1540.486 790.02)'
                  d='M1526 762.3h29v55.3h-29z'
                />
                <path
                  transform='rotate(30 1222.368 625.205)'
                  d='M1207.9 597.6h29v55.3h-29z'
                />
                <path d='M1052.5 458.9h29v55.3h-29zM872.7 765.7h29V821h-29z' />
                <path
                  transform='rotate(90 304.463 958.766)'
                  d='M293.1 937h22.7v43.4h-22.7z'
                />
                <path d='M524.1 554.2h29v55.3h-29zM1275.3 444h29v55.3h-29z' />
                <path
                  transform='rotate(-30 1280.284 359.659)'
                  d='M1265.8 332h29v55.3h-29z'
                />
              </symbol>
            </defs>
            <g className='layer'>
              <use id='svg_355' xlinkHref='#svg_354' />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Page2;
